import { Language } from 'app/model/constant';
export const LANG_TH_NAME = Language.th;

export const LANG_TH_TRANS = {
  'hello world': 'สวัสดีชาวโลก',
  'menu-bar-home': 'หน้าหลัก',
  'menu-bar-account': 'บัญชีของฉัน',
  'menu-bar-profile': 'จัดการข้อมูลผู้ใช้',
  'menu-bar-booking': 'การจอง',
  'menu-bar-approval': 'รายการที่ต้องอนุมัติ',
  'menu-bar-my-budget': 'สิทธิ์และวงเงินการจองที่พัก',
  'menu-bar-fleet-card': 'บัตรฟลีท (Fleet Card)',
  'menu-bar-setting-account': 'ความปลอดภัยบัญชี',
  'menu-bar-login': 'เข้าสู่ระบบ',
  'menu-bar-logout': 'ออกจากระบบ',
  'menu-bar-baht': 'บาท',
  'menu-bar-baht-opposite': 'THB',
  'menu-bar-baht-accommodation': 'ที่พัก',
  'menu-bar-baht-business-events': 'จัดกรุ๊ปองค์กร / อีเวนต์',
  'menu-bar-co-working-space': 'Co-working space',
  'menu-bar-flight': 'ตั๋วเครื่องบิน',
  'menu-bar-car-rental': 'รถเช่า',
  'menu-bar-help': 'ช่วยเหลือ',
  'menu-bar-language': 'ภาษา',
  'menu-bar-language-choice-en': 'อังกฤษ',
  'menu-bar-language-choice-th': 'ไทย',
  'menu-bar-currency': 'สกุลเงิน',
  'menu-bar-switch-company': 'จองภายใต้บริษัท',
  'menu-bar-setting': 'ตั้งค่า',
  'menu-bar-pre-approval-requests': 'คำขออนุมัติล่วงหน้า',
  'menu-bar-pre-approval-approvals': 'รายการขออนุมัติล่วงหน้า',

  'switch-language-title': 'ภาษา',
  'switch-currency-title': 'สกุลเงิน',
  'switch-language-currency-title': 'ภาษาและสกุลเงิน',
  'switch-language-currency-sub-title': 'ระบบจะแปลงและแสดงราคาเป็นสกุลเงินที่ท่านเลือก โดยสกุลเงินที่ท่านจะชำระนั้นอาจแตกต่างออกไปขึ้นอยู่กับการจองของท่าน และอาจมีการคิดค่าบริการด้วยเช่นกัน',

  'btn-register': 'สมัครใช้งาน',
  'btn-joinus': 'เข้าร่วมกับเรา',
  'btn-back': 'กลับ',
  'btn-cancel': 'ยกเลิก',
  'btn-clear': 'ล้างข้อมูล',
  'btn-choose': 'เลือก',
  'btn-go-to-booking': 'ไปที่การจองของฉัน',
  'btn-export': 'ดึงไฟล์รายงาน',
  'btn-clear-selection': 'ยกเลิกการเลือกทั้งหมด',
  'btn-clear-selection-mb': 'ยกเลิกการเลือก',
  'btn-confirm': 'ยืนยัน',
  'btn-close': 'ปิด',
  'btn-submit': 'ตกลง',

  'link-view-map': 'ดูแผนที่',
  'map-marker-room-not-available': 'ไม่มีห้องว่าง',

  'footer-company-name': 'บริษัท แอสเซนด์ แทรเวิล จำกัด (สำนักงานใหญ่)',
  'footer-address-01': 'เลขที่ 89 อาคารเอไอเอ แคปปิตอล เซ็นเตอร์',
  'footer-address-02': 'ชั้นที่ 18-19 ถนนรัชดาภิเษก แขวงดินแดง',
  'footer-address-03': 'เขตดินแดง กรุงเทพมหานคร 10400',
  'footer-new-address-01': 'เลขที่ 101 ทรู ดิจิทัล พาร์ค อาคารกริฟฟิน',
  'footer-new-address-02': 'ชั้น 12A ถนนสุขุมวิท แขวงบางจาก',
  'footer-new-address-03': 'เขตพระโขนง กรุงเทพมหานคร 10260',
  'footer-license': 'ใบอนุญาตบริษัททัวร์ : 11/08384',
  'footer-call-center': 'ติดต่อสอบถาม',
  'footer-customer-support': 'ติดต่อเรา',
  'footer-customer-help': 'ช่วยเหลือ',
  'footer-customer-terms': 'เงื่อนไขการใช้บริการ',
  'footer-customer-terms-02': 'นโยบายความเป็นส่วนตัว',
  'footer-customer-cookies': 'นโยบายคุกกี้',


  'province-hauhin': 'หัวหิน / ชะอำ',
  'province-pattaya': 'พัทยา',
  'province-chiang-mai': 'เชียงใหม่',
  'province-phuket': 'ภูเก็ต',
  'province-krabi': 'กระบี่',
  'province-koh-samui': 'เกาะสมุย',
  'province-bangkok': 'กรุงเทพมหานคร',
  'province-khao-lak': 'เขาหลัก',
  'province-koh-chang': 'เกาะช้าง',
  'province-kanchanaburi': 'กาญจนบุรี',


  'search-top-destination': 'สถานที่ที่น่าสนใจ',
  'search-top-destination-sub': 'ค้นพบสถานที่ใหม่ที่สามารถสร้างแรงบันดาลใจให้กับคุณ',

  'search-box-title': 'ค้นหาและจองที่พัก',
  'search-box-title-sub': 'รวมที่พักสำหรับเดินทางไปทำงานหรือไปท่องเที่ยวส่วนตัว หลากหลายสไตล์ตามใจคุณ',
  'search-box-topic-travel': 'ท่องเที่ยว',
  'search-box-topic-work': 'ทำงาน',
  'search-box-tooltip-title': 'ต่างกันอย่างไร ?',
  'search-box-tooltip-travel': 'ค้นหาที่พักสำหรับการพักผ่อนของคุณ โดยการจองจะไม่เชื่อมโยงกับบัญชีบริษัท',
  'search-box-tooltip-work': 'ค้นหาที่พักสำหรับผู้เดินทางติดต่อธุรกิจได้อย่างง่ายดาย',
  'search-box-topic-title': 'เดินทางเพื่อ',
  'search-box-want': 'คุณต้องการเดินทางไปที่ใด?',
  'search-box-want-placeholder': 'พิมพ์จุดหมายปลายทาง หรือ ชื่อที่พัก',
  'search-box-check-in': 'เช็คอิน',
  'search-box-check-in-calendar': 'วันที่เช็คอิน',
  'search-box-check-out': 'เช็คเอาท์',
  'search-box-check-out-calendar': 'วันที่เช็คเอาท์',
  'search-box-room': 'จำนวนห้อง',
  'search-box-guest': 'จำนวนผู้เข้าพัก',
  'search-box-btn-search': 'ค้นหา',
  'search-box-destination': 'จุดหมายปลายทาง',
  'search-box-props': 'ที่พัก',
  'search-box-hotel': 'ที่พัก/โรงแรม',
  'search-box-result-search': 'ผลการค้นหา',
  'search-box-recent-searches': 'ผลการค้นหาล่าสุด',
  'search-box-near-by': 'ค้นหาจากตำแหน่งของคุณ',
  'search-box-near-by-you': 'ที่พักใกล้ตำแหน่งของคุณ',
  'your-location': 'ตำแหน่งของคุณ',
  'location-not-found': 'ไม่สามารถระบุตำเเหน่งของคุณได้',
  'location-message-not-found': 'กรุณาตั้งค่าเปิดสิทธิ์การแชร์ข้อมูลตำแหน่งที่ตั้งก่อนค้นหาที่พักจากตำแหน่งของคุณ',
  'enter': 'ตกลง ',
  'search-box-room-in-choose': 'ห้อง',
  'search-box-adult': 'ผู้ใหญ่',
  'search-box-guest-count': 'จำนวนห้องและผู้เข้าพัก',
  'search-box-child': 'เด็ก',
  'search-box-child-age': 'อายุเด็ก (ปี)',
  'search-box-person': 'คน',
  'search-box-want-read': 'จุดหมายปลายทาง',
  'search-box-check-in-out-read': 'ช่วงวันเข้าพัก',
  'search-box-guest-read': 'จำนวนห้องและผู้เข้าพัก',
  'search-box-btn-cancel-change': 'ยกเลิกการเปลี่ยนแปลง',
  'search-box-btn-change': 'เปลี่ยนการค้นหา',
  'search-box-point_of_interest': 'จุดที่น่าสนใจ',

  'search-box-over-budget-checkbox-label': 'แสดงที่พักเกินวงเงินและคำนวณส่วนต่างที่ต้องจ่ายเพิ่มเอง',
  'search-box-over-budget-hover-info-label': 'คุณสามารถจองที่พักที่เกินจากวงเงินได้โดยการชำระค่าส่วนเกินเอง',
  'search-box-over-budget-hover-credit-card-label': 'บัตรเครดิตส่วนตัว',

  'search-box-error-purpose': 'กรุณาเลือกวัตถุประสงค์การเดินทาง',
  'search-box-error-destination': 'กรุณาระบุจุดหมายปลายทางหรือโรงแรมที่พัก',
  'search-box-error-work-1-room': 'การจองเพื่อทำงานสามารถจองได้ครั้งละ 1ห้อง และ ไม่เกิน 2 คน',
  'search-box-error-work-2-person': 'การจองเพื่อทำงานสามารถจองได้ห้องละไม่เกิน 2 คน',
  'search-box-error-work-no-child': 'การจองเพื่อทำงานไม่สามารถจองแบบมีเด็กได้',
  'search-box-error-feature-not-allow': 'เนื่องจากบริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้รวมวงเงินการจอง',
  'search-box-error-code-ref-expired': 'เนื่องจากรหัสสำหรับรวมวงเงินหมดอายุแล้ว',
  'search-box-error-code-ref-incorrect': 'เนื่องจากรหัสสำหรับรวมวงเงินไม่ถูกต้อง',


  'search-box-budget-per-night': 'คุณมีวงเงินในการจองที่พักอยู่ <strong>{currency} {budget}</strong> /ห้อง/คืน',
  'search-box-budget-per-month': 'วงเงินต่อเดือนที่คุณได้รับคือ <strong>{currency} {budgetPerMonth}</strong> /เดือน',
  'search-box-budget-per-year': 'วงเงินต่อปีที่คุณได้รับคือ <strong>{currency} {budgetPerYear}</strong> /ปี',
  'search-box-budget-per-month-per-year': 'วงเงินต่อเดือนและต่อปีที่คุณได้รับคือ <strong>{currency} {budgetPerMonth}</strong> /เดือน และ <strong>{currency} {budgetPerYear}</strong> /ปี',
  'search-box-budget-unlimited': 'คุณมีวงเงินต่อห้องต่อคืนไม่จำกัด',
  'search-box-new-budget-per-night': 'คุณมีวงเงินใหม่ในการจองที่พักอยู่ <strong>{currency} {budget}</strong> /ห้อง/คืน',
  'search-box-new-budget-unlimited': 'คุณมีวงเงินใหม่ในการจองที่พักต่อห้องต่อคืนไม่จำกัด',
  'search-box-see-all-my-budget': 'ดูวงเงินทั้งหมด',
  'search-box-share-budget': 'รวมวงเงินกับผู้ร่วมเดินทาง',
  'search-box-share-budget-tooltips': 'คุณสามารถจองห้องพักโดยการรวมวงเงินกับผู้ร่วมเดินทางท่านอื่นได้',
  'search-box-cancel-share-budget': 'ยกเลิกการรวมวงเงิน',
  'budget-unlimited': 'ไม่จำกัด',
  'search-box-tooltips-share-budget-detail-title': 'คุณได้รวมกับวงเงินของผู้ร่วมเดินทาง',
  'search-box-tooltips-share-budget-detail-booker-budget': 'วงเงินของคุณ',
  'search-box-tooltips-share-budget-detail-co-booker-budget': 'วงเงินของผู้ร่วมเดินทาง',
  'search-box-tooltips-share-budget-detail-total-budget': 'วงเงินใหม่ในการจองที่พักต่อห้องต่อคืนของคุณ',
  'search-box-tooltips-share-budget-detail-apply-co-budget': 'มีการจำกัดวงเงินในการจองห้องพักสำหรับผู้เข้าพัก 2 คน',

  'account-menu-bar-profile': 'จัดการข้อมูลผู้ใช้',
  'account-menu-bar-share-budget-code': 'สร้างรหัสสำหรับรวมวงเงิน',
  'account-menu-bar-my-budget': 'สิทธิ์และวงเงินการจองที่พัก',
  'account-menu-bar-fleet-card': 'บัตรฟลีท',
  'account-menu-bar-account-security': 'ความปลอดภัยบัญชี',
  'account-menu-bar-logout': 'ออกจากระบบ',

  'account-change-password-headline': 'เปลี่ยนรหัสผ่าน',
  'account-change-password-title': 'เปลี่ยนรหัสผ่าน',
  'account-change-password-new': 'รหัสผ่านใหม่',
  'account-change-password-new-fill': 'พิมพ์รหัสผ่านใหม่ที่นี่',
  'account-change-password-confirmation': 'ยืนยันรหัสผ่านใหม่',
  'account-change-password-confirmation-fill': 'พิมพ์รหัสผ่านใหม่อีกครั้ง',
  'account-change-password-button-submit': 'บันทึก',
  'account-change-password-button-cancel': 'ยกเลิก',
  'account-change-password-validation-text': 'รหัสผ่านต้องประกอบไปด้วย',
  'account-change-password-validation-length-text': 'อักขระอย่างน้อย 8-16 ตัว โดยมีตัวอักษรภาษาอังกฤษ ตัวเลข หรืออักขระพิเศษ เช่น @ $ ! % * # ? &',
  'account-change-password-validation-uppercase-text': 'ตัวอักษรภาษาอังกฤษตัวพิมพ์ใหญ่ อย่างน้อย 1 ตัว',
  'account-change-password-validation-lowercase-text': 'ตัวอักษรภาษาอังกฤษตัวพิมพ์เล็ก อย่างน้อย 1 ตัว',
  'account-change-password-validation-numeric-text': 'ตัวเลข 0-9 อย่างน้อย 1 ตัว',

  'account-security-title': 'ความปลอดภัยบัญชี',
  'account-security-email': 'อีเมล',
  'account-security-email-description': 'อีเมลนี้ใช้เข้าสู่ระบบ และเป็นอีเมลที่เราส่งรายละเอียดการจองไปให้คุณ',
  'account-security-password': 'รหัสผ่าน',
  'account-security-password-description': 'เปลี่ยนรหัสผ่านของคุณเป็นประจำเพื่อให้บัญชีของคุณปลอดภัยเสมอ',
  'account-security-password-action': 'เปลี่ยนรหัสผ่าน',
  'account-security-phone': 'เบอร์โทรศัพท์',
  'account-security-phone-action': 'เปลี่ยนเบอร์โทรศัพท์',
  'account-security-new-phone-action': 'เชื่อมเบอร์โทรศัพท์',
  'account-security-pin': 'รหัส PIN เพื่อความปลอดภัย',
  'account-security-pin-description': 'ใช้รหัส PIN สำหรับการชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทของคุณ',
  'account-security-pin-action': 'ตั้งรหัส PIN',

  'booking-my-booking': 'การจอง',
  'booking-my-booking-list': 'ทั้งหมด',
  'booking-my-booking-from': 'ช่วงระหว่างวันที่',
  'booking-my-booking-from2': 'ตั้งแต่',
  'booking-my-booking-until': 'ถึง',
  'booking-my-booking-until2': 'ถึง',
  'booking-my-booking-before': 'ก่อน',
  'booking-my-booking-id': 'หมายเลขการจอง',
  'booking-my-booking-booking-date': 'วันที่จอง / เวลาจอง',
  'booking-my-booking-payment-date': 'ตัดบัตรวันที่',
  'booking-my-booking-booker-cancel-date': 'โดยผู้จองวันที่',
  'booking-my-booking-booker-cancel-booker-date': 'โดยผู้จองหลักวันที่',
  'booking-my-booking-booker-cancel-co-booker-date': 'โดยผู้จองร่วมวันที่',
  'booking-my-booking-booker-cancel-name-date': 'โดย {name} วันที่',
  'booking-my-booking-booker-reject-supervisor-date': 'โดยผู้บังคับบัญชาของผู้จองหลักวันที่',
  'booking-my-booking-booker-reject-co-supervisor-date': 'โดยผู้บังคับบัญชาของผู้จองร่วมวันที่',
  'booking-my-booking-checkin': 'เช็คอิน',
  'booking-my-booking-checkout': 'เช็คเอาท์',
  'booking-my-booking-checkin-date': 'วันที่เช็คอิน',
  'booking-my-booking-bookingdate': 'วันที่จอง',
  'booking-my-booking-approved-date': 'วันที่อนุมัติ',
  'booking-my-booking-rejected-date': 'โดยผู้บังคับบัญชาวันที่',
  'booking-my-booking-roomtype': 'ประเภทห้องพัก',
  'booking-my-booking-re-booking': 'จองอีกครั้ง',
  'booking-my-booking-sumbit': 'จัดการจอง',
  'booking-my-booking-cancel': 'ยกเลิกการจองนี้',
  'booking-my-booking-map': 'ดูแผนที่',
  'booking-my-booking-review': 'ให้คะแนนรีวิวที่พัก',
  'booking-my-booking-review-published': 'ให้คะแนนรีวิวที่พักแล้ว',
  'booking-my-booking-btn-details': 'ดูรายละเอียด',
  'booking-my-booking-previous': 'ก่อนหน้า',
  'booking-my-booking-next': 'ถัดไป',
  'booking-my-booking-arranged-by': 'จัดเรียงตาม',
  'booking-my-booking-arranged-by-mobile': 'เรียงตาม',
  'booking-my-booking-all': 'การจองทั้งหมด',
  'booking-my-booking-search-text': 'หมายเลขการจอง',
  'booking-my-booking-search-not-found': 'ไม่พบหมายเลขการจอง',
  'booking-my-booking-text-booking-date': 'วัน/เวลาจอง',
  'booking-my-booking-text-total-room': 'จำนวนห้อง',
  'booking-my-room': 'ห้อง',
  'booking-my-night': 'คืน',
  'booking-my-guest': 'จำนวนผู้เข้าพัก',
  'booking-my-booking-text-total-max-guest': 'จำนวนผู้เข้าพักสูงสุดทั้งหมด',
  'booking-my-adult-text': 'ผู้ใหญ่',
  'booking-my-child-text': 'เด็ก',
  'booking-my-child': 'คน',
  'booking-my-adult': 'คน',
  'booking-my-status-success-booking': 'จองเรียบร้อยแล้ว',
  'booking-my-status-successfully-payment': 'ชำระเงินเรียบร้อยแล้ว',
  'booking-my-status-success-payment': 'จองและชำระเงินเรียบร้อยแล้ว',
  'booking-my-status-failure-payment': 'ชำระเงินไม่สำเร็จ',
  'booking-my-status-cancelled-booking': 'รายการจองถูกยกเลิก',
  'booking-my-status-inprogress': 'กำลังดำเนินการ',
  'booking-my-status-already-checkout': 'เช็คเอาท์แล้ว',
  'booking-my-status-failure-booking': 'ทำรายการไม่สำเร็จ',
  'booking-my-status-awaiting-approval': 'จองและรอการอนุมัติ',
  'booking-my-status-booking-approved': 'จองและอนุมัติเรียบร้อยแล้ว',
  'booking-my-status-booking-rejected': 'ถูกปฏิเสธการจอง',
  'booking-my-booking-filter-by': 'แสดง',
  'booking-my-booking-filter-by-all': 'ทั้งหมด',
  'booking-my-booking-filter-by-upcoming': 'กำลังจะเข้าพัก',
  'booking-my-booking-filter-by-check-in': 'เข้าพักอยู่',
  'booking-my-booking-filter-by-completed': 'เช็คเอาท์แล้ว',
  'booking-my-booking-filter-by-cancelled': 'ยกเลิก',
  'booking-my-booking-filter-by-failed': 'ทำรายการไม่สำเร็จ',
  'booking-my-booking-sort-by-booking-date': 'วันที่จอง',
  'booking-my-booking-sort-by-checkin-date': 'วันเข้าพัก',
  'booking-my-booking-sort-by-payment-date': 'วันชำระเงิน',
  'booking-my-booking-sort-by-booking-id': 'หมายเลขการจอง',

  // Approval List
  'approval-list': 'รายการที่ต้องอนุมัติ',
  'approval-list-search-text': 'หมายเลขการจอง',
  'approval-list-search-not-found': 'ไม่พบหมายเลขการจอง',
  'approval-list-search-empty': 'ยังไม่มีรายการจอง',
  'approval-list-filter-by': 'แสดง',
  'approval-list-sort-by': 'จัดเรียงตาม',
  'approval-list-filter-by-all': 'ทั้งหมด',
  'approval-list-filter-by-waiting': 'รอการอนุมัติ',
  'approval-list-filter-by-approved': 'อนุมัติแล้ว',
  'approval-list-filter-by-cancelled': 'ยกเลิกการจอง',
  'approval-list-sort-by-booking-date': 'วันที่จอง',
  'approval-list-sort-by-checkin-date': 'วันเข้าพัก',
  'approval-list-requester-name': 'ผู้ขออนุมัติ',
  'approval-list-booking-id': 'หมายเลขการจอง',
  'approval-list-grand-total': 'ยอดรวม',
  'approval-list-button-detail': 'ดูรายละเอียด',
  'approval-list-status-approved': 'อนุมัติการจอง',
  'approval-list-status-booker-cancelled': 'รายการจองถูกยกเลิก',
  'approval-list-status-last-minute1': 'ไม่สามารถอนุมัติหรือปฏิเสธการจองได้',
  'approval-list-status-last-minute2': 'เนื่องจากเป็นการจอง ณ​ วันเข้าพัก',
  'approval-list-status-no-action': 'จองเรียบร้อยโดยไม่ผ่านการอนุมัติ',
  'approval-list-status-rejected': 'ปฏิเสธการจอง',
  'approval-list-approved-date': 'วันที่อนุมัติ',
  'approval-list-rejected-date': 'วันที่ปฏิเสธ',
  'approval-list-cancel-date': 'วันที่ยกเลิก',
  'approval-message-approve-success': 'รายการจองห้องพักได้รับการอนุมัติและดำเนินการเรียบร้อยแล้ว',
  'approval-message-approve-fail': 'ทำรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'approval-message-reject-success': 'รายการจองห้องพักถูกยกเลิกเรียบร้อยแล้ว',
  'approval-message-reject-fail': 'ทำรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',

  'approval-button-reject': 'ปฏิเสธการจอง',
  'approval-button-approve': 'อนุมัติการจอง',

  'approval-details-btn-back': 'กลับไปรายการที่ต้องอนุมัติ',
  'approval-details-contact-number': ' เบอร์ติดต่อ',

  // Payment Summary
  'payment-summary-cancel-header': 'รายการจองถูกยกเลิก',
  'payment-summary-reject-header': 'รายการจองถูกปฏิเสธ',

  'payment-summary-exclude-vat': 'ราคาทั้งหมดไม่รวมภาษี',
  'payment-summary-vat': 'ภาษีมูลค่าเพิ่ม 7%',
  'payment-summary-before-discount': 'ยอดรวมก่อนส่วนลด',
  'payment-summary-promotion-code-discount': 'ส่วนลดโค้ดโปรโมชั่น',
  'payment-summary-book-grand-total': 'ยอดรวมสุทธิ',
  'payment-summary-pay-credit-term-main-booker': 'เรียกเก็บไปยังบริษัทผู้จองหลัก',
  'payment-summary-pay-credit-term-co-booker': 'เรียกเก็บไปยังบริษัทผู้จองร่วม',
  'payment-summary-pay-credit-term-remark': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
  'payment-summary-taxes-fees': 'ภาษีและค่าธรรมเนียม',
  'payment-summary-price': 'ราคา',

  'payment-summary-pay-credit-term': 'ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
  'payment-summary-pay-credit-card': 'ชำระเงินด้วยบัตรเครดิต/เดบิต',
  'payment-summary-pay-credit-card-add': 'ชำระเงินเพิ่มด้วยบัตรเครดิต/เดบิต',
  'payment-summary-pay-true-money': 'ชำระเงินด้วยทรูมันนี่ วอลเล็ท',
  'payment-summary-pay-true-money-add': 'ชำระเงินเพิ่มด้วยทรูมันนี่ วอลเล็ท',
  'payment-summary-pay-corporate-fleet': 'ชำระเงินด้วยบัตรฟลีทบริษัท',
  'payment-summary-pay-personal-fleet': 'ชำระเงินด้วยบัตรฟลีทส่วนตัว',
  'payment-summary-pay-personal-fleet-add': 'ชำระเงินเพิ่มด้วยบัตรฟลีทส่วนตัว',

  'payment-summary-cancel-exclude-vat': 'ค่าธรรมเนียมการยกเลิกทั้งหมดไม่รวมภาษี',
  'payment-summary-cancel-pay-credit-term-main-booker': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองหลัก',
  'payment-summary-cancel-pay-credit-term-co-booker': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองร่วม',
  'payment-summary-cancel-pay-credit-term': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
  'payment-summary-cancel-pay-credit-card': 'สำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต',
  'payment-summary-cancel-pay-true-money': 'สำหรับการชำระเงินด้วยทรูมันนี่ วอลเล็ท',
  'payment-summary-cancel-pay-corporate-fleet': 'สำหรับการชำระเงินด้วยบัตรฟลีทบริษัท',
  'payment-summary-cancel-pay-personal-fleet': 'สำหรับการชำระเงินด้วยบัตรฟลีทส่วนตัว',
  'payment-summary-cancel-total-price': 'มูลค่าการจอง',
  'payment-summary-cancel-total-cancellation-fee': 'ค่าธรรมเนียมการยกเลิก',
  'payment-summary-cancel-total-cancellation-share-fee': 'ค่าธรรมเนียมการยกเลิกสำหรับการรับชำระเงิน',
  'payment-summary-cancel-total-cancellation-share-fee-main-booker': 'แบบส่งใบแจ้งหนี้ผู้จองหลัก',
  'payment-summary-cancel-total-cancellation-share-fee-co-booker': 'แบบส่งใบแจ้งหนี้ผู้จองร่วม',
  'payment-summary-cancel-grand-total-cancellation-fee': 'ค่าธรรมเนียมการยกเลิกสุทธิ',
  'payment-summary-cancel-grand-desc-main-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองหลัก',
  'payment-summary-cancel-grand-desc-co-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ผู้จองร่วม',

  'payment-summary-cancel-credit-card-refund': 'ยอดเงินคืนเข้าบัตรเครดิต/เดบิต',
  'payment-summary-cancel-true-money-refund': 'ยอดเงินคืนเข้าทรูมันนี่ วอลเล็ท',
  'payment-summary-cancel-corporate-fleet-refund': 'ยอดเงินคืนเข้าบัตรฟลีทบริษัท',
  'payment-summary-cancel-personal-fleet-refund': 'ยอดเงินคืนเข้าบัตรฟลีทส่วนตัว',

  'payment-summary-refund': 'ยอดเงินคืน',
  'payment-summary-booker': 'ผู้จองหลัก',
  'payment-summary-co-booker': 'ผู้จองร่วม',

  // Global form
  'landing-form-password-hint': 'รหัสผ่านจะต้องเป็นตัวอักษรภาษาอังกฤษ A-Z หรือ a-z หรือ ตัวเลข 0-9 หรือ อักขระพิเศษยกเว้น ซิงเกิลโคด(\'), ดับเบิ้ลโคด("), คอมม่า(,) และ แบ็กสแลช(\\) จำนวน 8-16 หลัก',

  // Create account form
  'landing-form-create-account-select': 'เลือกบริษัทหลัก',
  'landing-form-create-account-terms-and-conditions': 'เงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัว',
  'landing-form-create-account-accept': 'ฉันยอมรับ',

  // Verify account form
  'landing-form-verify-account-title': 'กรุณาระบุอีเมลบริษัทของคุณ',
  'landing-form-verify-account-enroll': 'หากคุณไม่แน่ใจว่าบริษัทของคุณเข้าร่วมกับ Ascend Travel แล้วหรือยัง',
  'landing-form-confirm-email-title': 'กรุณาตรวจสอบอีเมลของคุณ',
  'landing-form-confirm-email-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span><br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิก<br/>ภายใน 30 นาที หลังได้รับอีเมล<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
  'landing-form-confirm-email-footer': 'หากคุณไม่พบอีเมลยืนยันของคุณ คลิก',
  'landing-form-confirm-email-success-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span><br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิกค่ะ<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
  'landing-form-confirm-email-success-footer': 'เราได้ทำการส่งอีเมลเพื่อยืนยันให้คุณแล้ว หากคุณไม่พบอีเมลยืนยันของคุณ คลิก',
  'landing-form-verify-email-failure-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span><br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิกค่ะ<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
  'landing-verify-email-success': 'คุณทำการยืนยันการสมัครสมาชิก<br/>เรียบร้อยแล้ว',

  // Reset password
  'landing-form-reset-password-title': 'ตั้งรหัสผ่านใหม่',
  'landing-form-reset-password-success-title': 'คุณตั้งรหัสผ่านใหม่เรียบร้อยแล้ว',
  'landing-form-reset-password-success-description': 'คุณสามารถใช้รหัสผ่านใหม่ในการเข้าสู่ระบบได้',
  'landing-form-reset-password-expired-title': 'ลิงก์ตั้งรหัสผ่านหมดอายุ',
  'landing-form-reset-password-expired-description': 'กรุณากด "ตกลง" เพื่อตั้งรหัสผ่านใหม่<br/>แล้วทำการตรวจสอบอีเมลของคุณเพื่อทำการตั้งรหัสผ่านใหม่<br/>ภายใน 30 นาที หลังได้รับอีเมลอีกครั้ง',
  'landing-form-action-link-fail-description': 'มีข้อผิดพลาดเกิดขึ้น<br/>กรุณาลองใหม่อีกครั้ง',

  // Login form
  'landing-form-required-login': 'กรุณาระบุรหัสผ่านของคุณ',
  'landing-form-forget-password': 'ลืมรหัสผ่าน ?',
  'landing-form-login-failure-title': '<p class="bold">อีเมลหรือรหัสผ่านของคุณไม่ถูกต้อง</p>',
  'landing-form-login-failure-description': 'กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'affiliate-form-login-title': 'Welcome to Corporate Secure Page',
  'affiliate-form-login-desc': 'Login with your organizational account.',
  'affiliate-form-login-username-required': 'Please enter your username',
  'affiliate-form-login-password-required': 'Please enter your password',
  'affiliate-form-login-button': 'Login',
  'affiliate-form-login-failure': 'Incorrect username or password. <br>Please check and try it again.',
  'affiliate-form-login-failure-cost-center-or-cost-owner-missing': 'Sorry, your cost center or cost center owner is missing! Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
  'affiliate-form-login-failure-technical-problems': 'Login failed due to technical problems from TrueHR. Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
  'affiliate-dialog-ok-button': 'OK',
  'error-unable-to-connect-SSO': 'ไม่สามารถเชื่อมต่อกับระบบ SSO ได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง หรือติดต่อฝ่าย IT ขององค์กร',

  // Forgot password form
  'landing-form-forgot-password-title': 'กรุณาระบุอีเมลบริษัทของคุณ',
  'landing-form-forgot-password-description': 'หากคุณต้องการตั้งรหัสผ่านใหม่ กรุณาระบุอีเมลที่ใช้ในการสมัคร',
  'landing-form-forgot-password-success-title': '<p class="forget-password-title">กรุณาตรวจสอบอีเมลของคุณ</p>',
  'landing-form-forgot-password-success-description': 'เราได้ทำการส่งอีเมลไปยัง<br/><span class="color-main">[email]</span> เรียบร้อยแล้ว<br/>กรุณาตรวจสอบอีเมลของคุณเพื่อทำการตั้งรหัสผ่านใหม่<br/>ภายใน 30 นาที หลังได้รับอีเมล',
  'landing-form-forgot-password-fail-message': 'การขอตั้งรหัสผ่านใหม่ไม่สำเร็จ <br/>กรุณากด "ตกลง" เพื่อตั้งรหัสผ่านใหม่อีกครั้ง',

  // Register / Join us form
  'landing-form-register-title': 'สนใจเข้าร่วมกับ Ascend Travel?',
  'landing-form-register-description': 'เนื่องจากบริษัทของคุณยังไม่ได้เข้าร่วมกับ Ascend Travel หากคุณสนใจที่จะใช้บริการของเรา กรุณาระบุข้อมูลของคุณเพื่อให้ทีมงานของเราติดต่อกลับคุณค่ะ',
  'landing-form-join-us-title': 'สนใจเข้าร่วมกับ Ascend Travel',
  'landing-form-join-us-description': 'หากคุณสนใจที่จะใช้บริการของเรา กรุณาระบุข้อมูลของคุณเพื่อให้ทีมงานของเราติดต่อกลับคุณค่ะ',
  'landing-form-register-success-title': '<p class="bold">เราได้รับข้อมูลของคุณเรียบร้อยแล้ว</p>',
  'landing-form-register-success-description': 'ทีมงานของเราจะติดต่อกลับคุณอย่างเร็วที่สุดค่ะ<br/>ขอบคุณที่ให้ความสนใจที่จะใช้บริการของเราค่ะ',
  'landing-form-join-us-error-title': 'การส่งข้อมูลของคุณล้มเหลว',
  'landing-form-join-us-error-description': 'กรุณาติดต่อ +66(0) 2-020-2351 หรือ Support@ascendtravel.com',
  'landing-form-register-error-title': 'การสมัครใช้งานของคุณล้มเหลว',
  'landing-form-register-error-description': 'กรุณาติดต่อ +66(0) 2-020-2351 หรือ Support@ascendtravel.com',

  // Verify register email
  'landing-form-verify-email-expired-title': 'ขออภัยค่ะ ลิงค์สำหรับเปิดใช้งานของคุณ<br/>ได้หมดอายุแล้ว',
  'landing-form-verify-email-expired-description': '<br/>เราได้ทำการส่งอีเมลยืนยันไปยังอีเมลของคุณอีกครั้ง<br/>กรุณาตรวจสอบอีเมลและทำการยืนยันการสมัครสมาชิก<br/>ภายใน 30 นาที หลังได้รับอีเมล<br/>*ถ้าไม่พบกรุณาตรวจสอบในกล่องจดหมายขยะ',
  'landing-form-verify-email-invalid-title': 'ลิงค์สำหรับเปิดใช้งานของคุณไม่ถูกต้อง',
  'landing-form-verify-email-invalid-description': 'กรุณาระบุอีเมลของคุณเพื่อส่งอีเมลยืนยันอีกครั้ง',

  // Login
  'landing-login-unable-get-company-feature': 'ระบบไม่สามารถดึงข้อมูลบริษัทได้ กรุณาติดต่อ Call Center เพื่อตรวจสอบข้อมูลเพิ่มเติม<br/>Call center +66(02) 2-020-2351',

  // Guideline
  'guideline-password': 'พิมพ์รหัสผ่านของคุณที่นี่',
  'guideline-confirm-password': 'ยืนยันรหัสผ่านของคุณที่นี่',
  'guideline-email': 'email@company.com',
  'guideline-name': 'ชื่อ/นามสกุล',
  'guideline-firstname': 'ชื่อ',
  'guideline-lastname': 'นามสกุล',
  'guideline-contact-number': '0XXXXXXXXX',
  'guideline-company': 'ชื่อบริษัท',
  'guideline-position': 'ตำแหน่งในบริษัท',
  'guideline-company-website': 'เว็บไซต์บริษัท (ถ้ามี)',
  'guideline-company-travelling-expense': 'ค่าใช้จ่ายการเดินทางของบริษัท (ถ้ามี)',

  // Validation message
  'validation-required-name': 'กรุณาระบุชื่อ/นามสกุลของคุณ',
  'validation-required-firstname': 'กรุณาระบุชื่อของคุณ',
  'validation-required-lastname': 'กรุณาระบุนามสกุลของคุณ',
  'validation-required-full-name': 'กรุณาระบุชื่อและนามสกุลของคุณ',
  'validation-required-email': 'กรุณาระบุอีเมลบริษัทของคุณ',
  'validation-required-contact-number': 'กรุณาระบุเบอร์ติดต่อของคุณ',
  'validation-required-company': 'กรุณาระบุชื่อบริษัทของคุณ',
  'validation-required-select-company': 'กรุณาเลือกบริษัทหลักของคุณ ',
  'validation-required-position': 'กรุณาระบุตำแหน่งของคุณ',
  'validation-required-accept-terms': 'กรุณากดยอมรับข้อกำหนดและเงื่อนไขในการสมัครสมาชิก',
  'validation-required-password': 'รหัสผ่านจะต้องเป็นตัวอักษรภาษาอังกฤษ A-Z หรือ a-z หรือ ตัวเลข 0-9 หรือ อักขระพิเศษยกเว้น ซิงเกิลโคด(\'), ดับเบิ้ลโคด("), คอมม่า(,) และ แบ็กสแลช(\\) จำนวน 8-16 หลัก',
  'validation-required-new-password': 'กรุณาระบุรหัสผ่านใหม่ของคุณ ',
  'validation-required-confirm-new-password': 'กรุณายืนยันรหัสผ่านใหม่ของคุณ ',
  'validation-previously-used-new-password': 'กรุณาตั้งรหัสผ่านอีกครั้งด้วยรหัสผ่านที่คุณไม่เคยใช้มาก่อน',
  'validation-required-title': 'กรุณาระบุชื่อบริษัท หรือ ชื่อ-นามสกุล',
  'validation-required-tax-number': 'กรุณาระบุหมายเลขประจำตัวผู้เสียภาษี หรือ หมายเลขบัตรประชาชน',
  'validation-invalid-tax-number': 'หมายเลขประจำตัวผู้เสียภาษี หรือหมายเลขบัตรประชาชนต้องเป็นตัวเลข 10 หรือ 13 หลักเท่านั้น',
  'validation-required-invoice-address': 'กรุณาระบุที่อยู่สำหรับออกใบกำกับภาษี หรือ ใบเสร็จ ',
  'validation-required-group-select-birth-date': 'กรุณาระบุวัน เดือน และปีเกิดที่ถูกต้อง',
  'validation-pattern-email': 'อีเมลของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'validation-pattern-name': 'ชื่อของคุณจะต้องเป็นตัวอักษร a-z A-Z',
  'validation-pattern-firstname': 'ชื่อของคุณจะต้องเป็นตัวอักษร a-z A-Z',
  'validation-pattern-lastname': 'นามสกุลของคุณจะต้องเป็นตัวอักษร a-z A-Z',
  'validation-pattern-full-name': 'กรุณาระบุชื่อและนามสกุลของผู้เข้าพักเป็นภาษาอังกฤษเท่านั้น',
  'validation-pattern-contact-number': 'กรุณาระบุเบอร์ติดต่อที่ถูกต้อง',
  'validation-min-length-password': 'รหัสผ่านจะต้องมีจำนวน 8-16 หลัก',
  'validation-max-length-password': 'รหัสผ่านจะต้องมีจำนวน 8-16 หลัก',
  'validation-match-password': 'รหัสผ่านไม่ตรงกับยืนยันรหัสผ่าน กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'validation-required-select-your-company': 'กรุณาเลือกบริษัท',
  'validation-required-time-of-birth': 'กรุณาเลือกช่วงเวลาเกิด',

  'btn-create-account': 'สมัครสมาชิก',
  'btn-try-again': 'ลองอีกครั้ง',
  'btn-continue': 'ดำเนินการต่อ',
  'btn-ok': 'ตกลง',
  'btn-submit-information': 'ส่งข้อมูล',
  'btn-login': 'เข้าสู่ระบบ',
  'link-resend': 'ส่งอีเมลยืนยันอีกครั้ง',
  'btn-request-new-password': 'ตั้งรหัสผ่านใหม่',
  'login-not-sure': 'หากคุณไม่แน่ใจว่าบริษัทของคุณเข้าร่วมกับ Ascend Travel แล้วหรือยัง',
  'click-here': 'คลิกที่นี่',
  'forget-password': 'ลืมรหัสผ่าน ?',
  'placeholder-password': 'พิมพ์รหัสผ่านของคุณที่นี่',

  'my-profile-headline': 'ข้อมูลส่วนตัวของฉัน',
  'my-profile-personal-informations': 'ข้อมูลส่วนตัว',
  'my-profile-edit-profile': 'แก้ไขข้อมูล',
  'my-profile-name': 'ชื่อ/นามสกุล',
  'my-profile-firstname': 'ชื่อ',
  'my-profile-lastname': 'นามสกุล',
  'my-profile-full-name-label': 'ชื่อ/นามสกุล',
  'my-profile-full-name-placeholder': 'ชื่อ-นามสกุลภาษาอังกฤษ',
  'my-profile-member-code': 'รหัสสมาชิก',
  'my-profile-birthday': 'วันเกิด',
  'my-profile-company-name': 'ชื่อบริษัท',
  'my-profile-nationality': 'สัญชาติ',
  'my-profile-phone-number': 'เบอร์ติดต่อ',
  'my-profile-phone-number-placeholder': 'e.g. 0812345678',
  'my-profile-email': 'อีเมล',
  'my-profile-working-position': 'ตำแหน่ง',
  'my-profile-tax-invoice': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'my-profile-add-tax': 'เพิ่มที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'my-profile-edit': 'แก้ไขข้อมูล',
  'my-profile-delete': 'ลบข้อมูล',
  'my-profile-edit-presonal-profile': 'แก้ไขข้อมูลส่วนตัว',
  'my-profile-birthdate-remark': 'ข้อมูลนี้ถูกใช้และประมวลผลสำหรับการค้นหาที่พักเสริมพลังบวก หากต้องการเปลี่ยนแปลงวันเกิด สามารถติดต่อ Call Center: <b>+66(0) 2-020-2351</b> / Line Official Account: <b>@AscendTravel</b>',

  'my-profile-edit-button-submit': 'บันทึกข้อมูล',
  'my-profile-edit-button-cancel': 'ยกเลิก',

  'my-profile-change-password-success-title': 'คุณตั้งรหัสผ่านใหม่เรียบร้อยแล้ว คุณสามารถใช้รหัสผ่านนี้ในการเข้าสู่ระบบครั้งถัดไป',
  'my-profile-change-password-success-description': '',
  'my-profile-change-password-failure-title': 'ตั้งรหัสผ่านใหม่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'my-profile-change-password-failure-description': '',

  'my-profile-edit-success-title': 'อัพเดทข้อมูลเรียบร้อยแล้ว',
  'my-profile-edit-success-description': '',
  'my-profile-edit-failure-title': 'ไม่สามารถอัพเดทข้อมูลได้',
  'my-profile-edit-failure-description': 'กรุณาลองใหม่อีกครั้ง',
  'my-profile-edit-address-failure-title': 'ไม่สามารถอัพเดทที่อยู่ได้',
  'my-profile-edit-address-failure-description': 'กรุณาลองใหม่อีกครั้ง',

  'my-profile-address-form-tax-number': 'หมายเลขประจำตัวผู้เสียภาษี',
  'my-profile-address-form-company-name': 'ชื่อบริษัท/ชื่อ-นามสกุล',
  'my-profile-address-form-company-name-placeholder': 'ชื่อบริษัท/ชื่อ-นามสกุล',
  'my-profile-address-form-tax-number-id': 'หมายเลขประจำตัวผู้เสียภาษี/บัตรประชาชน',
  'my-profile-address-form-tax-number-id-placeholder': 'หมายเลขประจำตัวผู้เสียภาษี/บัตรประชาชน',
  'my-profile-address-form-billing-address': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'my-profile-address-form-billing-address-placeholder': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'my-profile-address-form-btn-cancel': 'ยกเลิก',
  'my-profile-address-form-btn-submit': 'บันทึก',

  'my-profile-delete-address-success': 'ลบที่อยู่สำเร็จ',
  'my-profile-delete-address-failure': 'ลบที่อยู่ไม่สำเร็จ',
  'my-profile-delete-address-failure-text': 'กรุณาลองใหม่อีกครั้ง',
  'my-profile-confirm-msg-delete-address': 'คุณต้องการลบข้อมูลที่อยู่นี้ใช่หรือไม่?',
  'my-profile-confirm-msg-type-address': 'ข้อมูลที่อยู่',
  'my-profile-confirm-msg-type-profile': 'ข้อมูลส่วนตัว',
  'my-profile-confirm-msg': 'คุณยังไม่ได้ทำการบันทึก{dataType}ที่แก้ไขต้องการออกจากหน้านี้โดยไม่บันทึกใช่หรือไม่?',

  'my-profile-address-dialog-button-delete': 'ลบ',
  'my-profile-address-dialog-button-cancel': 'ยกเลิก',
  'my-profile-address-dialog-button-close': 'ปิด',

  'facility-title': 'สิ่งอำนวยความสะดวก',
  'facility-title-room': 'สิ่งอำนวยความสะดวกภายในห้องพัก',
  'show-more-btn': 'แสดงทั้งหมด',
  'show-less-btn': 'ย่อ',
  'description-title': 'ข้อมูลที่พัก',
  'occupancy-policy-title': 'นโยบายการเข้าพักของที่พัก',
  'occupancy-policy-remark-title': 'ข้อมูลเพิ่มเติม',
  'remark': 'หมายเหตุ',
  'my-profile-subscription': 'การแจ้งเตือน',

  // Child policy
  'child-policy-title': 'เด็กและเตียงเสริม',
  'child-policy-table-guest-age': 'อายุผู้เข้าพัก',
  'child-policy-table-extrabed': 'เตียงเสริม',
  'child-policy-min-guest-age-all-age': 'เด็กทุกคนเข้าพักได้ (ไม่จำกัดอายุ)',
  'child-policy-min-guest-age': ' ผู้เข้าพักต้องมีอายุอย่างน้อย {x} ปี',
  'child-policy-infant-policy': 'เด็กทารกอายุ {from}-{to} ปี (รวมอายุ {to} ปี)',
  'child-policy-infant-description': 'กรุณาสอบถามที่พักโดยตรงเกี่ยวกับบริการเตียงเด็ก/เปล',
  'child-policy-child-policy': 'เด็กอายุ {from}-{to} ปี (รวมอายุ {to} ปี)',
  'child-policy-adult-policy': 'ผู้เข้าพักอายุ {from} ขึ้นไป ถือเป็นผู้ใหญ่',
  'child-policy-free-stay-description': 'พักฟรีหากใช้เตียงที่มีอยู่แล้ว',
  'child-policy-stay-description': 'ต้องใช้เตียงเสริม',
  'child-policy-free-description': 'ขอรับบริการเตียงเสริมได้โดยตรงกับที่พัก (อาจมีค่าใช้จ่ายเพิ่มเติม)',
  'child-policy-description': 'ขอรับบริการเตียงเสริมได้โดยตรงกับที่พัก (อาจมีค่าใช้จ่ายเพิ่มเติม)',

  // Review rating component in level-D
  'review-rating-title': 'คะแนนจากผู้เข้าพัก',
  'review-uncommonThings-title': 'รีวิวพิเศษจากผู้เข้าพัก',
  'review-uncommonThings-title-right': 'จากรีวิวผู้เข้าพักทั้งหมดพบว่า',

  // Product lists page
  'productlists-popular-filter': 'ตัวกรองยอดนิยม',
  'productlists-price-per-night': 'ราคาต่อคืน',
  'productlists-price': 'ราคา/คืน',
  'productlists-price-low-high': 'ราคาน้อยไปมาก',
  'productlists-price-high-low': 'ราคามากไปน้อย',
  'productlists-hotel-star': 'ระดับดาว',
  'productlists-hotel-star-1-5': 'ระดับดาว 1-5',
  'productlists-hotel-star-5-1': 'ระดับดาว 5-1',
  'productlists-no-star-rating': 'ไม่มีระดับดาว',
  'productlists-your-balance': 'คุณมีวงเงินในการจองที่พักอยู่ THB X,XXX/ห้อง/คืน',
  'productlists-sorting': 'จัดเรียงตาม',
  'productlists-filter': 'กรองผลการค้นหา',
  'productlists-filter-by': 'เลือกตัวกรอง',
  'productlists-more': 'เพิ่มเติม',
  'productlists-recommendation': 'ที่พักแนะนำ',
  'productlists-score': 'คะแนนจากผู้เข้าพัก',
  'productlists-poi-distance': 'ระยะทาง',
  'productlists-hotel-name': 'ชื่อโรงแรม',
  'productlists-hotel-name-sorting-a-z': 'ชื่อโรงแรม A-Z',
  'productlists-hotel-name-sorting-z-a': 'ชื่อโรงแรม Z-A',
  'productlists-special-price': 'ราคาที่ท่านเห็นเป็น ราคาพิเศษสำหรับบริษัท เท่านั้น',
  'productlists-available-room': 'เหลือเพียง {3} ห้อง เท่านั้น!',
  'product-booknow': 'จองวันนี้ ชำระเงินวันที่ {9 ก.ค. 60}',
  'productlists-see-room': 'ดูห้องพัก',
  'productlists-night': 'คืน',
  'productlists-no-room-left': 'ไม่มีห้องพัก ณ ช่วงวันที่คุณต้องการเข้าพัก',
  'productlists-recommended-title': 'ราคาดีลส่วนลดพิเศษสำหรับพนักงานองค์กรที่จองผ่าน Ascend Travel เท่านั้น',
  'productlists-found-01': 'พบที่พัก',
  'productlists-found-02': 'แห่ง',
  'productlists-found-03': 'แสดง',
  'productlists-pop-up-error': 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง',
  'productlists-pop-up-error-missing-email-header': 'ไม่พบอีเมลของผู้ใช้จากระบบ CPF Web Service',
  'productlists-pop-up-error-missing-email': 'กรุณาติดต่อหน่วยงาน CPF HRIS โดยการแจ้งผ่านระบบ Ask HR<br/>1. เข้าไปที่หน้าเว็บไซต์ <a class="link-hover-style" href="https://cpffamily.cpf.co.th" target="_blank">https://cpffamily.cpf.co.th</a><br/>2. เลือกไปที่ <span class="bold">HR-eXp</span> และกดปุ่ม <span class="bold">Ask HR</span> ด้านขวาบนของหน้าจอ',
  'productlists-pop-up-error-across-month': 'บริษัทของคุณไม่อนุญาตให้จองที่พักแบบคร่อมเดือน',
  'productlists-pop-up-error-across-month-share-budget': 'บริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้จองที่พักแบบคร่อมเดือน',
  'productlists-not-found': 'ขออภัยค่ะ ไม่พบที่พักจากคำที่คุณค้นหา คุณอาจเลือกจากสถานที่ค้นหายอดนิยมแทน',
  'productlists-business-desination': 'ระยะห่างจากจุดหมาย',
  'productlists-business-desination-kilometer': 'กม.',
  'productlists-business-distance': 'ห่างจาก {poi} {km} กม.',
  'productlists-hotel-review': 'คะแนนรีวิว',
  'productlists-hotel-review-9': 'ยอดเยี่ยม: 9+',
  'productlists-hotel-review-8': 'ดีเยี่ยม: 8+',
  'productlists-hotel-review-7': 'ดีมาก: 7+',
  'productlists-hotel-review-6': 'คะแนนรีวิว: 6+',
  'productlists-hotel-review-nonreview-newhotel': 'เพิ่งเปิดหรือยังรอการรีวิวจากผู้เข้าพัก',
  'productlists-filter-header': 'กรองผลการค้นหา',
  'productlists-filter-clear': 'ล้างทั้งหมด',
  'productlists-filter-submit': 'แสดงผลการค้นหา',
  'productlists-filter-show-more-item': 'แสดงทั้งหมด',
  'productlists-filter-facility': 'สิ่งอำนวยความสะดวก',
  'productlists-filter-include-breakfast': 'แสดงเฉพาะที่พักที่มี<br>บริการอาหารเช้าฟรี',
  'productlists-filter-popup-include-breakfast': 'แสดงเฉพาะที่พักที่มีบริการอาหารเช้าฟรี',
  'productlists-filter-location': 'ทำเลที่ตั้ง',
  'productlists-filter-location-search': 'ค้นหาทำเลที่ตั้ง',
  'productlists-filter-over-budget': 'แสดงที่พักเกินวงเงิน<br>ของคุณ',
  'productlists-filter-popup-over-budget': 'แสดงที่พักเกินวงเงินของคุณ',
  'productlists-filter-clear-btn': 'ล้าง',
  'productlists-over-budget': 'เกินวงเงินการจองของคุณ',
  'productlists-bestSeller': 'ที่พักยอดนิยม',
  'productlists-topBooking': 'ที่พักที่ยอดจองสูงสุด',
  'productlists-bestReview': 'ที่พักที่มีคะแนนรีวิวสูงสุด',
  'productlists-specialRecommendation': 'ที่พักแนะนำ',
  'productlists-holidayOffer': 'ที่พักแนะนำช่วงวันหยุด',
  'productlists-midMonth': 'ดีลพิเศษช่วงกลางเดือน',
  'productlists-summerDeal': 'ดีลพิเศษรับหน้าร้อน',
  'productlists-flashDeal': 'ด่วน! ดีลพิเศษวันนี้',
  'productlists-bestDeal': 'ดีลจองที่พักที่ดีที่สุด',
  'productlists-room-breakfast': 'รวมอาหารเช้า',
  'productlists-positive-energy': 'เสริมพลังบวก',
  'productlists-positive-energy-work': 'การงาน',
  'productlists-positive-energy-wealth': 'การเงิน',
  'productlists-positive-energy-love': 'ความรัก',
  'productlists-positive-energy-family': 'ครอบครัว',
  'productlists-positive-energy-friendship': 'มิตรภาพ',
  'productlists-positive-energy-fortune': 'โชคลาภ',
  'productlists-positive-energy-health': 'สุขภาพ',
  'productlists-positive-energy-patronage': 'อุปถัมภ์',
  'productlists-positive-energy-reputation': 'ชื่อเสียง',

  // Product list - guest review rating title
  'product-review-rating-exceptional': 'ยอดเยี่ยม',
  'product-review-rating-excellent': 'ดีเยี่ยม',
  'product-review-rating-very-good': 'ดีมาก',
  'product-review-rating-review-score': 'คะแนนรีวิว',


  // Product detail page
  'product-detail-choose-your-room': `เลือกห้องพักที่คุณต้องการ`,
  'product-detail-room-type': `ประเภทห้องพัก`,
  'product-detail-room-condition': `รายละเอียดและเงื่อนไข`,
  'product-detail-number-of-guest': `ผู้เข้าพัก`,
  'product-detail-price-today': `ราคาต่อคืน`,
  'product-detail-amount-room': `จำนวนห้อง`,
  'product-detail-room-last-five': `เหลือเพียง {room} ห้อง เท่านั้น!`,
  'product-detail-room-breakfast': `รวมอาหารเช้า`,
  'product-detail-room-all-inclusive': `รวมอาหารเช้า กลางวัน เย็น และเครื่องดื่ม`,
  'product-detail-room-full-board': `รวมอาหารเช้า กลางวัน และเย็น`,
  'product-detail-room-half-board': `รวมอาหารเช้าและกลางวัน หรือ อาหารเช้าและเย็น`,
  'product-detail-room-only': `ไม่รวมอาหารเช้า`,
  'product-detail-room-condition-cancellation-fee': 'ยกเลิกมีค่าธรรมเนียม',
  'product-detail-room-cancellation-policy': `เงื่อนไขการยกเลิกห้องพัก`,
  'product-detail-room-cancellation-non-refundable': `ราคาพิเศษ ขอรับเงินคืนไม่ได้`,
  'product-detail-room-cancellation-charge': `- หากยกเลิกหลังวันที่ {date} จะเสียค่าธรรมเนียมการยกเลิกห้องพัก {currency} {amount} ต่อห้อง`,
  'product-detail-room-cancellation-night': `- หากยกเลิกหลังวันที่ {date} จะเสียค่าธรรมเนียมการยกเลิกห้องพักเป็นราคา เท่ากับค่าห้องพัก {night} คืนแรก`,
  'product-detail-room-cancellation-percent': `- หากยกเลิกหลังวันที่ {date} จะเสียค่าธรรมเนียมการยกเลิกห้องพัก {percent}% จากราคาสุทธิที่จองห้องพัก`,
  'product-detail-room-cancellation-free': `ฟรี! ค่าธรรมเนียมการยกเลิก หากยกเลิกก่อนวันที่ {date}`,
  'product-detail-room-paylater-description': `จองวันนี้ ชำระเงินวันที่ {date}`,
  'product-detail-budget-limit': `คุณมีวงเงินในการจองที่พักอยู่ <strong>{x}</strong> /ห้อง/คืน`,
  'product-detail-new-budget-limit': `คุณมีวงเงินใหม่ในการจองที่พักอยู่ <strong>{x}</strong> /ห้อง/คืน`,
  'product-detail-room-over-limit': `เกินวงเงิน`,
  'product-detail-room-over-price': `จ่ายเพิ่มจากวงเงิน`,
  'product-detail-room-night': `/คืน`,
  'product-detail-tooltip-price-per-night': `1 ห้อง x 1 คืน`,
  'product-detail-tooltip-user-budget': `วงเงินต่อห้องต่อคืนของคุณ`,
  'product-detail-tooltip-pay-over-budget': `ชำระเงินเพิ่มเอง`,
  'product-detail-image-map-description': `*คลิกที่แผนที่เพื่อดูที่พักใกล้เคียง`,
  'product-detail-review-mysterious-things': 'เจอสิ่งลี้ลับ',
  'product-detail-review-pest': 'เจอสัตว์รบกวน',
  'product-detail-bathroom': 'ห้องน้ำ',
  'product-detail-private-bathroom': 'ห้องน้ำส่วนตัว',
  'product-detail-shared-bathroom': 'ห้องน้ำส่วนรวม',
  'product-detail-bedroom': 'ห้องนอน',
  'product-detail-sqm': 'ตารางเมตร',
  'product-detail-information': 'รายละเอียดเพิ่มเติม',
  'extra-bed-include-in-room-price': 'รวมค่าบริการเตียงเสริมแล้ว',
  'extra-bed-include': `รวมเตียงเสริม {text} เตียง`,
  'product-detail-room-note-title': 'สิทธิประโยชน์และข้อมูลเพิ่มเติม',
  'product-detail-room-note-see-more': 'ดูเพิ่มเติม',

  'room-detail-title': `รายละเอียดห้องพัก`,
  'room-not-available-line-1': `ขออภัยค่ะ ไม่มีห้องว่างในวันที่คุณเลือก`,
  'room-not-available-line-2': `กรุณาเปลี่ยนวันเข้าพักของคุณ`,

  'room-price-change-line-1': 'ราคาห้องพักมีการเปลี่ยนแปลง',
  'room-price-change-line-2': 'คุณสามารถดูราคาใหม่ได้',
  'room-price-change-line-3': 'ตามข้อมูลด้านล่าง',
  'room-price-change-space': '',
  'room-price-change-col-1': 'ประเภทห้องพัก',
  'room-price-change-col-2': 'ราคาก่อนหน้า',
  'room-price-change-col-3': 'ราคาใหม่',
  'room-price-btn-accept': 'ยอมรับ',
  'room-price-btn-back': 'กลับไปค้นหาใหม่',

  'show-photo': `ดูรูปภาพ`,
  'product-description-text-sha-title': 'SHA : Amazing Thailand Safety & Health Administration',
  'product-description-text-sha-plus-title': 'SHA Plus : Amazing Thailand Safety & Health Administration',
  'product-description-text-sha-desc': 'ผู้ประกอบการผ่านมาตรฐานแนวทางความปลอดภัยด้านสุขอนามัย ออกให้โดยการท่องเที่ยวแห่งประเทศไทย (ททท.)',
  'product-description-text-sha-plus-desc': 'ผู้ประกอบการผ่านมาตรฐานแนวทางความปลอดภัยด้านสุขอนามัย ออกให้โดยการท่องเที่ยวแห่งประเทศไทย (ททท.) และพนักงานในสถานประกอบการได้รับการฉีดวัคซีนแล้วมากกว่า ร้อยละ 70',
  'product-description-text-sha-certificate-id': 'รหัสผู้ประกอบการ',
  'product-description-text-property-opened': 'ที่พักสร้างปี',
  'product-description-text-recent-renovation': 'ที่พักปรับปรุงล่าสุดปี',

  'sanitized-stay-title': 'สุขภาพและอนามัย',
  'product-detail-dialog-continue-with-my-budget': 'คุณต้องการจองต่อโดยใช้วงเงินคุณเอง?',
  'product-detail-dialog-continue-with-credit-card': 'คุณต้องการจองต่อโดยชำระเงินค่าที่พักเอง?',
  'product-detail-dialog-continue-with-multi-payment': 'คุณต้องการจองต่อโดยชำระเงินค่าที่พักเพิ่มเอง?',
  'product-detail-dialog-continue-confirm-with-my-budget': 'จองต่อโดยใช้วงเงินคุณเอง',
  'product-detail-dialog-continue-confirm-with-credit-card': 'จองต่อโดยชำระค่าที่พักเอง',
  'product-detail-dialog-continue-confirm-with-multi-payment': 'จองต่อโดยชำระค่าที่พักเพิ่มเอง',
  'product-detail-dialog-continue-sub-text-with-my-budget': 'คุณไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ หากคุณเลือก จองต่อโดยใช้วงเงินคุณเอง เราจะทำการยกเลิกการวงเงินให้โดยอัตโนมัติ',
  'product-detail-dialog-continue-sub-text-with-credit-card': 'คุณไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ หากคุณเลือก จองต่อโดยชำระค่าที่พักเอง เราจะทำการยกเลิกการวงเงินให้โดยอัตโนมัติ',
  'product-detail-dialog-continue-sub-text-with-multi-payment': 'คุณไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ หากคุณเลือก จองต่อโดยชำระค่าที่พักเพิ่มเอง เราจะทำการยกเลิกการวงเงินให้โดยอัตโนมัติ',
  'product-detail-dialog-btn-continue': 'จองต่อ',

  // booking
  'booking-cancellation-fee': 'ค่าธรรมเนียมยกเลิก',
  'booking-cancellation-fee-2': 'ค่าธรรมเนียม',
  'booking-cancellation-fee-3': 'ปฏิเสธรายการจองห้องพัก',
  'booking-cancellation-free': 'ไม่มีค่าธรรมเนียม',
  'booking-cancellation-free-2': 'ท่านสามารถปฏิเสธรายการจองห้องพักโดยไม่มีค่าธรรมเนียมการยกเลิก',
  'booking-cancellation-booking-id': 'หมายเลขการจอง',
  'booking-cancellation-if-cancel-text': 'หากท่านยกเลิกการจองจะมีค่าธรรมเนียมในการยกเลิกดังนี้',
  'booking-cancellation-if-cancel-text-2': 'หากท่านปฏิเสธรายการจองห้องพัก จะมีค่าธรรมเนียมในการยกเลิกดังนี้',
  'booking-cancellation-room-type': 'ประเภทห้องพัก',
  'booking-cancellation-total': 'ค่าธรรมเนียมการยกเลิกสุทธิ',
  'booking-cancellation-note': 'หมายเหตุ',
  'booking-cancellation-note-text': 'ค่าธรรมเนียมการยกเลิกอาจมีการเปลี่ยนแปลง ขึ้นอยู่กับเวลาที่ทำการยกเลิก',
  'booking-cancellation-promotion-text': 'กรณีใช้โค้ดโปรโมชั่น ค่าธรรมเนียมการยกเลิกคำนวณจากราคาสุทธิหลังหักส่วนลด หรือเป็นไปตามที่บริษัทกำหนด',
  'booking-cancellation-btn-confirm': 'ยืนยันการยกเลิก',
  'booking-cancellation-btn-confirm-2': 'ปฏิเสธการจอง',
  'booking-cancellation-btn-close': 'กลับไปก่อนหน้า',
  'booking-cancellation-empty': 'ยังไม่มีรายการจอง',
  'booking-cancel-success': 'ทำการยกเลิกรายการจองหมายเลข {bookingID} เรียบร้อยแล้ว',
  'booking-cancel-failure': 'ยกเลิกรายการจองหมายเลข {bookingID} ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'booking-cancel-date': 'วันยกเลิก',
  'booking-cancellation-credit-terms': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
  'booking-cancellation-credit-terms-main-booker': 'ผู้จองหลัก',
  'booking-cancellation-credit-terms-co-booker': 'ผู้จองร่วม',
  'booking-cancellation-credit-card': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต',
  'booking-cancellation-true-money': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยทรูมันนี่ วอลเล็ท ',
  'booking-cancellation-corporate-fleet': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรฟลีทบริษัทของเจ้าของบัตร',
  'booking-cancellation-personal-fleet': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรฟลีทส่วนตัวของเจ้าของบัตร',
  'booking-cancellation-multipayment': 'แบ่งชำระเงิน 2 ช่องทาง',
  'booking-cancellation-reject-reason-label': 'เหตุผลการปฏิเสธ',
  'booking-cancellation-reject-reason-placeholder': 'ระบุเหตุผล...',
  'booking-cancellation-reject-reason-error-required': 'กรุณาระบุเหตุผลการปฏิเสธ',
  'booking-cancellation-refund-details': 'เราไม่สามารถดำเนินการคืนเงินโดยอัตโนมัติทันทีที่ได้รับคำสั่งยกเลิกการจอง คุณจะต้องดำเนินการ <span class="refund-themselves"">ขอรับเงินคืนด้วยตนเอง</span><br>กรุณาติดต่อ <b>Call Center : +66(0) 2-020-2351</b> หรือ <b>Line Official Account : @AscendTravel</b>',
  'product-menu-photo': `รูปภาพ`,
  'product-menu-room': `เลือกห้องพัก`,
  'product-menu-detail': `ข้อมูลที่พัก`,
  'product-menu-facility': `สิ่งอำนวยความสะดวก`,
  'booking-arranged-by': 'จัดเรียงตาม',
  'booking-report': 'ดึงรายงานการจอง (.xlsx)',
  'booking-report-dialog-title': 'ดึงรายงานการจองจากช่วงวันเข้าพัก',
  'booking-report-check-in-from': 'จาก',
  'booking-report-check-in-to': 'ถึง',
  'booking-report-placeholder-from': 'อ. 1 ม.ค. 62',
  'booking-report-placeholder-to': 'พฤ. 31 ม.ค. 62',
  'booking-report-information': 'รายงานนี้มีเฉพาะรายการจองที่ชำระเงินด้วยรูปแบบ Credit Terms เท่านั้น',
  'booking-report-data-not-found': 'ไม่มีรายการจองที่พักด้วยการชำระเงินแบบส่งใบแจ้งหนี้ (Credit Terms) ในช่วงวันที่คุณเลือก',
  'booking-report-export-error': 'การดึงไฟล์รายงานการจองของคุณล้มเหลว<br>กรุณาทำรายการอีกครั้ง',
  'dialog-booking-report-error': 'กรุณาระบุช่วงวันเข้าพัก',
  'booking-condition-popup-title': 'เงื่อนไขการยกเลิกห้องพัก',
  'booking-condition-popup-detail-1': 'หากยกเลิกหลังวันที่',
  'booking-condition-popup-detail-2': 'จะเสียค่าธรรมเนียมการยกเลิกห้องพัก THB',
  'booking-condition-popup-detail-3': 'ต่อห้อง',

  // cart
  'cart-booking-detail': `สรุปรายการจอง`,
  'cart-price-for': `ราคาสำหรับ`,
  'cart-night': `คืน`,
  'cart-time-from': `ตั้งแต่`,
  'cart-time-until': `จนถึง`,
  'cart-room': `ห้อง`,
  'cart-room-type-detail': `รายละเอียดห้องพัก`,
  'cart-grand-total': `ยอดรวมสุทธิ`,
  'cart-include-vat-label': `ราคานี้รวมภาษีและค่าธรรมเนียมแล้ว`,
  'cart-credit-card-label': `สำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต`,
  'cart-non-refund-label': `ราคานี้ไม่สามารถเปลี่ยนแปลงหรือคืนเงินได้`,
  'cart-pay-on-label': `จะตัดเงินวันที่`,
  'cart-book-now': `จองทันที`,
  'cart-select-room': `กรุณาเลือกจำนวนห้องพัก`,
  'cart-button-continue': `ดำเนินการต่อ`,
  'cart-button-confirm-to-book': `ยืนยันการจอง`,
  'cart-surcharge-include': `ราคานี้รวมภาษี, {text} และค่าธรรมเนียมแล้ว`,
  'cart-surcharge-exclude': `ราคาไม่รวม (เรียกเก็บโดยที่พัก): {text}`,
  'cart-seperate-payment': `แบ่งรายการชำระเงินเป็น 2 ช่องทาง`,
  'cart-seperate-payment-credit-terms': `แบ่งรายการชำระเงิน`,
  'cart-pay-credit-terms': `ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท`,
  'cart-pay-corporate-fleet': `ชำระเงินด้วยบัตรฟลีทบริษัท`,
  'cart-pay-personal-fleet': `ชำระเงินด้วยบัตรฟลีทส่วนตัว`,
  'cart-pay-corporate-fleet-new-line': `ชำระเงินด้วยบัตร<br>ฟลีทบริษัท`,
  'cart-pay-personal-fleet-new-line': `ชำระเงินด้วยบัตร<br>ฟลีทส่วนตัว`,
  'cart-pay-debit-card': `ชำระเงินเพิ่มเอง`,
  'cart-multi-pay-label': `สำหรับการชำระเงินแบบ 2 ช่องทาง รายการชำระเงินเพิ่มเองจะตัดเงินวันที่`,
  'cart-max-guest': 'ผู้เข้าพักสูงสุด',
  'cart-adult-text': 'ผู้ใหญ่',
  'cart-child-text': 'เด็ก',
  'cart-adult': 'คน',
  'cart-child': 'คน',
  'cart-budget-no-remaning': 'คุณต้องชำระเงินค่าที่พักเอง ',
  'cart-budget-detail-below': ' คุณต้องชำระเงินเพิ่มเองตามรายละเอียดด้านล่างนี้',
  'cart-budget-no-remaning-mobile': 'คุณต้องชำระเงินค่าที่พักเองตามรายละเอียด',
  'cart-budget-detail-mobile': 'คุณต้องชำระเงินเพิ่มเองตามรายละเอียด',
  'cart-booker': 'ผู้จอง',
  'cart-co-booker': 'ผู้ร่วมเดินทาง',
  'cart-cannot-share-budget': 'ไม่สามารถใช้วงเงินกับผู้ร่วมเดินทางได้ กรุณา',
  'cart-before-continuing': 'ก่อนดำเนินการต่อ',
  'cart-btn-cannot-share-budget': 'ยกเลิกการรวมวงเงิน',
  'cart-share-budget-detail-below': ' คุณต้องชำระเงินเพิ่มเองตามรายการชำระเงินด้านล่างนี้',
  'cart-budget-over-budget-mobile': 'คุณต้องชำระเงินค่าเพิ่มเองตามรายละเอียด',
  'cart-budget-over-budget-book-for-traveller': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ',
  'cart-budget-over-budget-book-for-traveller-sub-text': 'กรุณาตรวจสอบหรือเลือกห้องพักใหม่อีกครั้ง',
  'cart-currency-note': 'เราจะเรียกเก็บรายการจองของคุณในสกุลเงิน THB ราคาที่แสดงในสกุล {currency} เป็นราคาโดยประมาณจากการแปลงสกุลเงิน THB เป็นสกุลเงิน {currency} โดยอิงตามอัตราแลกเปลี่ยนปัจจุบัน (โปรดทราบว่าอัตราแลกเปลี่ยนอาจมีการเปลี่ยนแปลง)',
  'cart-approximate-price-in': 'ราคาโดยประมาณสกุลเงิน',
  'cart-taxes-fees': 'ภาษีและค่าธรรมเนียม',
  'cart-taxes-fees-description': 'ค่าบริการนี้รวมจำนวนเงินโดยประมาณที่ผู้ให้บริการด้านการเดินทาง (เช่น โรงแรม บริษัทเช่ารถ) จ่ายภาษี และ/หรือภาษีที่เราจ่ายให้กับหน่วยงานสรรพากรในการจองของคุณ (รวมถึงแต่ไม่จำกัดเพียงการขาย จำนวนผู้เข้าพัก และภาษีมูลค่าเพิ่ม) จำนวนนี้อาจรวมถึงจำนวนเงินใดๆ ที่เรียกเก็บจากเราสำหรับค่าธรรมเนียมรีสอร์ต ค่าทำความสะอาด และค่าธรรมเนียมอื่นๆ และ/หรือค่าธรรมเนียมที่เรา ซัพพลายเออร์โรงแรม และ/หรือเว็บไซต์ที่คุณจองเก็บไว้เป็นส่วนหนึ่งของค่าตอบแทนสำหรับบริการของเรา และ/หรือบริการของพวกเขา ซึ่งจะแตกต่างกันไปตามปัจจัยต่างๆ เช่น สถานที่ จำนวน และวิธีการจองของคุณ สำหรับรายละเอียดเพิ่มเติม โปรดดูข้อกำหนดและเงื่อนไข',
  'cart-terms-conditions': 'เมื่อทำการจองนี้ถือว่า คุณเข้าใจและยอมรับ',
  'cart-terms-conditions-and': 'และ',
  'cart-terms-conditions-supplier': 'ข้อกำหนดและเงื่อนไขของซัพพลายเออร์',
  'cart-terms-conditions-agent': 'เงื่อนไขการใช้บริการของเอเจนต์',
  'cart-price-info': 'ข้อมูลเกี่ยวกับราคา',
  'cart-discount': 'ส่วนลด',
  'cart-promotion-code': 'โค้ดโปรโมชั่น',
  'cart-select-code': 'เลือกโค้ดที่มีอยู่',
  'cart-promotion-code-discount': 'ส่วนลดจากโค้ดโปรโมชั่น',
  'cart-promotion-code-error-invalid_payment_method': 'กรุณาเปลี่ยนช่องทางการชำระเงินเพื่อใช้โค้ดนี้',
  'cart-promotion-code-error-reached_limit': 'กรุณาเลือกใช้โค้ดอื่น โค้ดนี้ถูกใช้ครบจำนวนสิทธิ์แล้ว',
  'cart-promotion-code-error-condition_not_met': 'กรุณาเลือกใช้โค้ดอื่น โค้ดนี้ไม่ตรงตามเงื่อนไขการจองนี้',
  'cart-dialog-use-promotion-code-title': 'ใช้โค้ดโปรโมชั่น',
  'cart-dialog-use-promotion-code-search-placeholder': 'ระบุโค้ดโปรโมชั่นของคุณที่นี่',
  'cart-dialog-use-promotion-code-best-deal': 'คุ้มค่าที่สุด',
  'cart-dialog-use-promotion-code-btn-search': 'ใช้โค้ด',
  'cart-dialog-use-promotion-code-search-error-invalid': 'โค้ดโปรโมชั่นไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'cart-dialog-use-promotion-code-discount': 'ส่วนลด {amount}',
  'cart-dialog-use-promotion-code-max-discount-per-book': 'ลดสูงสุด {amount}',
  'cart-dialog-use-promotion-code-min-spend-per-book': 'ยอดจองขั้นต่ำ {amount}',
  'cart-dialog-use-promotion-code-min-spend-per-book-no-limit': 'ไม่มียอดจองขั้นต่ำ',
  'cart-dialog-use-promotion-code-term-condition': 'เงื่อนไข',
  'cart-dialog-use-promotion-no-promotion-code': 'ไม่มีโค้ดที่ใช้ได้',
  'cart-dialog-use-promotion-credit-terms': 'เฉพาะเมื่อชำระเงินแบบส่งใบแจ้งหนี้ เท่านั้น',
  'cart-dialog-use-promotion-credit-debit-card-bank': 'เฉพาะเมื่อชำระเงินผ่านบัตรเครดิต/เดบิต {bank} เท่านั้น',
  'cart-dialog-use-promotion-credit-card': 'เฉพาะเมื่อชำระเงินผ่านบัตรเครดิต {bank}เท่านั้น',
  'cart-dialog-use-promotion-debit-card': 'เฉพาะเมื่อชำระเงินผ่านบัตรเดบิต {bank}เท่านั้น',
  'cart-dialog-use-promotion-payment': 'เฉพาะเมื่อชำระเงินผ่าน{payment} เท่านั้น',
  'cart-dialog-use-promotion-promotional-code-participating-payment-methods': 'เฉพาะเมื่อชำระเงินผ่านช่องทางที่ร่วมรายการเท่านั้น',
  'cart-dialog-use-promotion-discount': 'ส่วนลดจากโค้ดโปรโมชั่น',
  'cart-dialog-confirm-continue-without-promotion-code-title': 'ดำเนินการต่อโดยไม่ใช้โค้ด?',
  'cart-dialog-confirm-continue-without-promotion-code-desc': 'โค้ดโปรโมชันนี้ไม่เข้าเงื่อนไขของรายการจองนี้<br>คุณสามารถดำเนินการต่อโดยไม่ใช้โค้ด หรือกลับไปเลือกโค้ดใหม่ได้',
  'cart-dialog-confirm-continue-without-promotion-code-cancel': 'กลับไปเลือกโค้ดใหม่',
  'cart-dialog-confirm-continue-without-promotion-code-cancel-short': 'เลือกโค้ดใหม่',
  'cart-dialog-confirm-continue-without-promotion-code-confirm': 'ดำเนินการต่อโดยไม่ใช้โค้ด',
  'cart-dialog-error-session-expired-title': 'การค้นหานี้หมดอายุแล้ว',
  'cart-dialog-error-session-expired-description': 'เนื่องจากหมดเวลาสำหรับการจอง<br>กรุณาค้นหาใหม่อีกครั้ง',

  // Month
  'day-select': 'วัน',
  'year-select': 'ปี',
  'month-select': 'เดือน',
  'month-january': 'มกราคม',
  'month-february': 'กุมภาพันธ์',
  'month-march': 'มีนาคม',
  'month-april': 'เมษายน',
  'month-may': 'พฤษภาคม',
  'month-june': 'มิถุนายน',
  'month-july': 'กรกฏาคม',
  'month-august': 'สิงหาคม',
  'month-september': 'กันยายน',
  'month-october': 'ตุลาคม',
  'month-november': 'พฤศจิกายน',
  'month-december': 'ธันวาคม',

  // Thank you
  'thankyou-download-voucher': 'ดาวน์โหลดใบยืนยันการจองที่พัก',
  'thankyou-print-voucher': 'สั่งพิมพ์',
  'thankyou-office-address-name': 'บริษัท แอสเซนด์ แทรเวิล จำกัด (สำนักงานใหญ่) ',
  'thankyou-office-address-location': 'เลขที่ 89 อาคารเอไอเอ แคปปิตอล เซ็นเตอร์ ชั้นที่ 18-19 ถนนรัชดาภิเษก แขวงดินแดง เขตดินแดง กรุงเทพมหานคร 10400',
  'thankyou-office-address-taxnum': 'เลขประจำตัวผู้เสียภาษี : 0105559069212',
  'thankyou-bookingId-ref': 'สำหรับอ้างอิงกับแอสเซนด์แทรเวิล',
  'thankyou-bookingId-hotel-ref-number': 'หมายเลขการจอง',
  'thankyou-bookingId-hotel-book-by': 'จองและชำระเงินโดย ',
  'thankyou-payment-title': 'ช่องทางการชำระเงิน',
  'thankyou-payment-detail': 'บัตรเครดิต/เดบิต',
  'thankyou-payment-detail-true-money': 'ทรูมันนี่ วอลเล็ท',
  'thankyou-payment-detail-2': 'คุณเลือกการชำระเงินแบบ Credit Terms',
  'thankyou-payment-creditcard-details': 'ชำระเงินผ่านบัตรเครดิต/เดบิต ง่ายๆ โดยไม่เสียค่าธรรมเนียม สะดวก รวดเร็ว และปลอดภัย ได้ตลอด 24 ชั่วโมง',
  'thankyou-payment-date': 'วันที่ชำระเงิน',
  'thankyou-booking-details': 'สรุปรายละเอียดการจอง',
  'thankyou-details-props-info': 'รายละเอียดที่พัก',
  'thankyou-details-props-name': 'ชื่อที่พัก',
  'thankyou-details-props-address': 'ที่อยู่',
  'thankyou-details-props-phone': 'เบอร์ติดต่อ',
  'thankyou-details-details': 'รายละเอียดการจอง',
  'thankyou-details-roomtype': 'ประเภทห้องพัก',
  'thankyou-details-price': 'ราคา',
  'thankyou-guest-order-number': 'ผู้เข้าพัก ',
  'thankyou-guest-special-request': 'คำขอพิเศษ ',
  'thankyou-room-condition': `เงื่อนไขห้องพัก`,
  'thankyou-details-vat': 'ราคาไม่รวมภาษี',
  'thankyou-price-vat': 'ภาษีมูลค่าเพิ่ม',
  'thankyou-price-total': 'ยอดรวมสุทธิ',
  'thankyou-thankyou-statement-01': 'ขอขอบคุณที่ให้ความไว้วางใจในการใช้บริการกับ Ascend Travel',
  'thankyou-thankyou-statement-02': 'ท่านสามารถติดต่อสอบถาม Call Center +66(0) 2-020-2351 เปิดให้บริการตลอด 24 ชั่วโมงทุกวัน',
  'thankyou-status-pay-now-success-title': 'รายการจองห้องพักของคุณชำระเงินเรียบร้อยแล้ว',
  'thankyou-status-pay-now-success-text': 'ขอบคุณที่ให้ความไว้วางใจในการใช้บริการ Ascend Travel ค่ะ',
  'thankyou-status-pay-later-success-title': 'รายการจองห้องพักของคุณเรียบร้อยแล้ว',
  'thankyou-status-pay-later-success-text': 'ขอบคุณที่ให้ความไว้วางใจในการใช้บริการ Ascend Travel ค่ะ',
  'thankyou-status-pay-now-fail-title': 'ชำระเงินผ่านช่องทางบัตรเครดิต/เดบิตไม่สำเร็จ',
  'thankyou-status-tmn-pay-now-fail-title': 'ชำระเงินผ่านทรูมันนี่ วอลเล็ทไม่สำเร็จ',
  'thankyou-status-fleet-pay-now-fail-title': 'ชำระเงินผ่านช่องทางบัตรฟลีทไม่สำเร็จ',
  'thankyou-status-payment-fail-title': 'ชำระเงินไม่สำเร็จ',
  'thankyou-status-fleet-pay-now-fail-sub-title': 'กรุณาตรวจสอบยอดเงินในบัตรของคุณ หรือ ติดต่อ Call Center +66(0) 2-020-2351',
  'thankyou-status-pay-now-fail-text': 'กรุณาตรวจสอบข้อมูลบัตรของคุณ หรือติดต่อธนาคารเจ้าของบัตร',
  'thankyou-status-tmn-pay-now-fail-default-text': 'กรุณาตรวจสอบบัญชีทรูมันนี่ วอลเล็ทของคุณ หรือติดต่อ TrueMoney Customer Care',
  'thankyou-status-payment-fail-text': 'กรุณาตรวจสอบบัญชีของคุณ หรือทำรายการใหม่อีกครั้ง',
  'thankyou-status-tmn-pay-now-fail-invalid-card-number-text': 'บัญชีทรูมันนี่ วอลเล็ทไม่ถูกต้อง กรุณาติดต่อ TrueMoney Customer Care',
  'thankyou-status-tmn-pay-now-fail-insufficient-funds-text': 'เงินในบัญชีทรูมันนี่ วอลเล็ท เหลือไม่พอ กรุณาเติมเงินให้เพียงพอก่อนชำระเงิน',
  'thankyou-status-payment-fail-description': 'ชำระเงินไม่สำเร็จ',
  'thankyou-status-payment-credit-terms-fail-description': 'ไม่มีการเรียกเก็บยอดชำระไปยังบริษัทของคุณ',
  'thankyou-status-payment-credit-terms-share-budget-fail-description': 'ไม่มีการเรียกเก็บยอดชำระไปยังบริษัทของคุณ และบริษัทของผู้จองร่วม',
  'thankyou-status-payment-credit-card-fail-description': 'ไม่มีการเรียกเก็บยอดชำระไปยังธนาคารเจ้าของบัตร',
  'thankyou-status-payment-tmn-fail-description': 'ไม่มีการตัดยอดชำระจากบัญชีทรูมันนี่ วอลเล็ทของคุณ',
  'thankyou-status-payment-fleet-fail-description': 'ไม่มีการตัดยอดชำระจากบัตรฟลีทของคุณ',
  'thankyou-status-payment-account-fail-description': 'ไม่มีการตัดยอดชำระจากบัญชีของคุณ',
  'thankyou-status-seperate-payment-method': 'แบ่งรายการชำระเงินเป็น 2 ช่องทาง',
  'thankyou-more-information': 'ข้อมูลเพิ่มเติม',
  'thankyou-status-booking-success-title': 'รายการสั่งจองของคุณเรียบร้อยแล้ว',
  'thankyou-status-booking-success-text': 'คุณจะได้รับอีเมลยืนยันการจองอีกครั้ง<br />ขอบคุณที่ให้ความไว้วางใจในการใช้บริการกับ Ascend Travel ค่ะ',
  'thankyou-status-booking-fail-title': 'รายการจองห้องพักของคุณทำรายการไม่สำเร็จ',
  'thankyou-status-booking-fail-text': 'ทางเราต้องขออภัยอย่างสูงค่ะ เนื่องจากขณะนี้ห้องพักที่คุณต้องการมีลูกค้าหลายท่านสนใจ และห้องสุดท้ายพึ่งถูกจองไป',
  'thankyou-status-cannot-create-temp-booking-title': "รายการสั่งจองของคุณทำรายการไม่สำเร็จ",
  'thankyou-status-cannot-create-temp-booking-text': "กรุณาจองใหม่อีกครั้ง",
  'thankyou-status-timeout-title': 'กรุณาตรวจสอบรายการจองที่เมนู "การจองของฉัน"',
  'thankyou-status-timeout-text': "เนื่องจากระบบขัดข้องระหว่างทำรายการ ตรวจสอบรายการจอง",
  'thankyou-surcharge-exclude': `ราคาห้องพักไม่รวม {text} จะถูกเรียกเก็บโดยที่พัก และกรุณาขอใบเสร็จรับเงิน / ใบกำกับภาษี จากที่พักทุกครั้งเมื่อมีการชำระเงิน`,
  'thankyou-payment-successful': 'ชำระเงินเรียบร้อยแล้ว',
  'thankyou-booking-successful': 'จองเรียบร้อยแล้ว',
  'thankyou-booking-pay-on': 'ตัดบัตรวันที่',
  'thankyou-booking-credit-terms-title': 'ชำระเงินแบบส่งใบแจ้งหนี้',
  'thankyou-booking-credit-terms-success': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของคุณ <br/> ตามรอบบิลที่ได้ทำการตกลงกันไว้',
  'thankyou-booking-credit-terms-share-budget-success': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของคุณ และบริษัทของผู้จองร่วมตามรอบบิลที่ได้ทำการตกลงกันไว้',
  'thankyou-payment-detail-total-title': 'รายละเอียดราคารวมทั้งหมด',
  'thankyou-booking-id': 'หมายเลขการจอง',
  'thankyou-we-send-information': 'เราส่งรายละเอียดการจองไปที่',
  'thankyou-total-price': 'ยอดรวมสุทธิ',
  'thankyou-voucher': 'ใบยืนยันการจอง',
  'thankyou-tax-invoice': 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
  'thankyou-back-home-button': 'กลับหน้าหลัก',
  'thankyou-booking-detail-button': 'ดูรายละเอียดการจอง',
  'thankyou-check-booking-button': 'ตรวจสอบรายการจอง',
  'thankyou-on-process': 'เนื่องจากรายการจองอยู่ในระหว่างดำเนินการ',
  'thankyou-booking-corporate-fleet-title': 'บัตรฟลีทบริษัท',
  'thankyou-booking-personal-fleet-title': 'บัตรฟลีทส่วนตัว',


  // Booking Details
  'booking-details-btn-back': 'กลับไปรายการจอง',
  'booking-details-dropdown-title': 'ดาวน์โหลดเอกสาร',
  'booking-details-save-voucher': 'บันทึก Voucher',
  'booking-details-save-tax-invoice': 'บันทึก Tax Invoice',
  'booking-details-save-tax-invoice-cancel': 'บันทึก Tax Invoice Cancel',
  'booking-details-save-credit-note': 'บันทึก Credit Note',

  //Payment method detail component
  'payment-method-detail-payment-title': 'ช่องทางการชำระเงิน',
  'payment-method-detail-payment-date': 'วันที่ชำระเงิน',
  'payment-method-detail-payment-multi-payment-expand': 'ชำระเงินแบบส่งใบแจ้งหนี้ และบัตรเครดิต/เดบิต',
  'payment-method-detail-payment-credit-terms': 'ชำระเงินแบบส่งใบแจ้งหนี้',
  'payment-method-detail-payment-credit-card': 'บัตรเครดิต/เดบิต',
  'payment-method-detail-payment-true-money': 'ทรูมันนี่ วอลเล็ท',
  'payment-method-detail-payment-corporate-fleet': 'บัตรฟลีทบริษัท',
  'payment-method-detail-payment-personal-fleet': 'บัตรฟลีทส่วนตัว',
  'payment-method-detail-payment-date-credit-card': 'ตัดบัตรวันที่',
  'payment-method-detail-payment-date-credit-terms': 'ตามรอบบิลที่ได้ทำการตกลงกันไว้',
  'payment-method-detail-payment-date-credit-terms-no-charge': 'ไม่มีการเรียกเก็บยอดชำระไปยังบริษัทของคุณ',
  'payment-method-detail-payment-date-true-money-no-charge': 'ไม่มีการตัดยอดชำระจากบัญชีทรูมันนี่ วอลเล็ทของคุณ',
  'payment-method-detail-payment-date-credit-card-no-charge': 'ไม่มีการเรียกเก็บยอดชำระไปยังธนาคารเจ้าของบัตร',
  'payment-method-detail-payment-date-fleet-no-charge': 'ไม่มีการตัดยอดชำระจากบัตรฟลีทของคุณ',
  'payment-method-detail-payment-date-payment-no-charge': 'ไม่มีการตัดยอดชำระจากบัญชีของคุณ',
  'payment-method-detail-payment-date-refund-policy': 'นโยบายการคืนเงิน',
  'payment-method-detail-payment-date-refund-policy-details-credit-card': 'เราส่งเรื่องขอคืนเงินไปยังธนาคารทันทีที่ได้รับคำสั่งยกเลิกการจอง โดยการดำเนินการคืนเงินหลังจากนี้จะขึ้นอยู่กับนโยบายของแต่ละธนาคาร โดยทั่วไปแล้วผู้ถือบัตรจะได้รับเงินคืนในรอบบิลถัดไป สำหรับบัตรเดบิตจะได้รับเงินคืนใน 30-60 วัน',
  'payment-method-detail-payment-date-refund-policy-details-true-money': 'เราส่งเรื่องขอคืนเงินทันทีที่ได้รับคำสั่งยกเลิกการจอง กรณีลูกค้าชำระเงินผ่านช่องทาง True Money Wallet ระบบจะทำการคืนเงินกลับไปยัง True Money Wallet ที่ลูกค้าใช้ในการชำระเงิน โดยใช้ระยะเวลาประมาณ 14-30 วันทำการ',
  'payment-method-detail-payment-date-refund-policy-details-fleet': 'เราดำเนินการคืนเงินทันทีที่ได้รับคำสั่งยกเลิกการจอง โดยระบบจะทำการคืนเงินกลับไปยังบัตรฟลีทที่ลูกค้าใช้ในการชำระเงินภายใน 30 นาที',
  'payment-method-detail-payment-date-refund-policy-details-payment': 'เราไม่สามารถดำเนินการคืนเงินโดยอัตโนมัติทันทีที่ได้รับคำสั่งยกเลิกการจอง คุณจะต้องดำเนินการขอรับเงินคืนด้วยตนเอง กรุณาติดต่อ <b>Call Center : +66(0) 2-020-2351</b> หรือ <b>Line Official Account : @AscendTravel</b>',
  'payment-method-detail-payment-date-refund-policy-details-e-wallet': ' เราส่งเรื่องขอคืนเงินทันทีที่ได้รับคำสั่งยกเลิกการจอง กรณีลูกค้าชำระเงินผ่านช่องทาง Rabbit LINE Pay ระบบจะทำการคืนเงินกลับไปยัง Rabbit LINE Pay ที่ลูกค้าใช้ในการชำระเงิน โดยใช้ระยะเวลาประมาณ 14-30 วันทำการ',

  // Booking detail share component
  'booking-detail-bookingId-ref-number': 'หมายเลขการจอง',
  'booking-detail-bookingId-hotel-ref': 'หมายเลขอ้างอิงกับโรงแรม',
  'booking-detail-booking-date-and-time': 'วัน/เวลาจอง',
  'booking-detail-details-booking-detail-title': 'รายละเอียดการจอง',
  'booking-detail-details-checkin': 'เช็คอิน',
  'booking-detail-details-checkout': 'เช็คเอาท์',
  'booking-detail-details-from': 'ตั้งแต่',
  'booking-detail-details-before': 'จนถึง',
  'booking-detail-details-period': 'ระยะเวลาเข้าพัก',
  'booking-detail-details-night': 'คืน',
  'booking-detail-details-room-amount': 'จำนวนห้อง',
  'booking-detail-details-room': 'ห้อง',
  'booking-detail-details-total-max-guest': 'ผู้เข้าพักสูงสุดทั้งหมด',
  'booking-detail-details-max-guest': 'ผู้เข้าพักสูงสุด',
  'booking-detail-details-adult-text': 'ผู้ใหญ่',
  'booking-detail-details-child-text': 'เด็ก',
  'booking-detail-details-adult': 'คน',
  'booking-detail-details-child': 'คน',
  'booking-detail-details-children-age': '(อายุ {age} ปี)',
  'booking-detail-details-room-guest-amount': 'จำนวนห้องและผู้เข้าพัก',
  'booking-detail-details-and': 'และ',

  'booking-detail-details-traveller-info-title': 'ข้อมูลผู้เข้าพัก',
  'booking-detail-details-traveller-info-table-room-header': 'ห้องพัก',
  'booking-detail-details-traveller-info-table-guest-header': 'ผู้เข้าพัก',
  'booking-detail-details-traveller-info-table-guest-number-header': 'ผู้เข้าพักคนที่',
  'booking-detail-details-traveller-info-table-supervisor-header': 'ผู้บังคับบัญชา',
  'booking-detail-details-traveller-info-table-pending-status': 'รอการอนุมัติ',
  'booking-detail-details-traveller-info-table-approved-status': 'อนุมัติการจอง',
  'booking-detail-details-traveller-info-table-rejected-status': 'ปฏิเสธการจอง',
  'booking-detail-details-traveller-info-table-unable-status': 'ไม่สามารถอนุมัติหรือปฏิเสธการจองได้',

  'booking-detail-details-room-detail-title': `รายละเอียดห้องพัก`,
  'booking-detail-details-room-title': `1 ห้อง x`,
  'booking-detail-details-room-guest': `ผู้เข้าพัก`,
  'booking-detail-details-room-special-request': 'คำขอพิเศษ',
  'booking-detail-cancellation-policy-free-of-charge': 'ฟรี! ค่าธรรมเนียมการยกเลิก หากยกเลิกก่อนวันที่',
  'booking-detail-details-room-non-refund': 'ราคาพิเศษ ขอรับเงินคืนไม่ได้',
  'booking-detail-room-cancellation-policy': `เงื่อนไขการยกเลิกห้องพัก`,
  'booking-detail-cancellation-policy-charge': '- หากยกเลิกหลังวันที่ {date} จะเสียค่าธรรมเนียมการยกเลิกห้องพัก {currencycode} {cancelFee} ต่อห้อง',
  'booking-detail-room-price-total': 'ยอดรวม',
  'booking-detail-details-room-benefits': `สิทธิประโยชน์และข้อมูลเพิ่มเติม`,

  'booking-detail-details-booker-information-title': 'ข้อมูลผู้จอง',
  'booking-detail-details-main-booker-information-title': 'ข้อมูลผู้จองหลัก',
  'booking-detail-details-booker-name': 'ชื่อผู้จอง',
  'booking-detail-details-main-booker-name': 'ชื่อผู้จองหลัก',
  'booking-detail-details-booker-id': 'รหัสสมาชิก',
  'booking-detail-details-booker-phonenum': 'เบอร์ติดต่อ',
  'booking-detail-details-booker-email': 'อีเมล',
  'booking-detail-details-supervisor-fullname': 'ชื่อผู้บังคับบัญชา',
  'booking-detail-details-supervisor-email': 'อีเมล',
  'booking-detail-details-booker-company-name': 'ชื่อบริษัท/ชื่อ',
  'booking-detail-details-booker-company-tax': 'หมายเลขประจำตัวผู้เสียภาษี/บัตรประชาชน',
  'booking-detail-details-booker-company-address': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'booking-detail-details-credit-terms-title': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ - ชำระเงินแบบส่งใบแจ้งหนี้',
  'booking-detail-details-credit-card-title': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ - บัตรเครดิต/เดบิต',
  'booking-detail-details-true-money-title': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ - ทรูมันนี่ วอลเล็ท',
  'booking-detail-details-co-booker-information-title': 'ข้อมูลผู้จองร่วม',
  'booking-detail-details-co-booker-name': 'ชื่อผู้จองร่วม',
  'booking-detail-arrival-time': 'เวลาถึงที่พัก',

  'cart-notify-over-room-limit': 'คุณสามารถทำการจองพักห้องได้สูงสุด 9 ห้อง/การจอง เท่านั้นค่ะ',
  'cart-notify-add-cart-fail': 'ไม่สามารถจองที่พักนี้ได้ชั่วคราว<br/> กรุณาจองที่พักอื่นค่ะ<br/> ขออภัยในความไม่สะดวก',
  'cart-notify-add-cart-fail-fit-invalid-number-of-adult': 'ไม่สามารถจองห้องพักได้ (FIT9)<br />กรุณาติดต่อ Call Center<br />Call Center : +66(0) 2-020-2351',

  // checkout
  'checkout-step1': 'รายละเอียดการจอง',
  'checkout-step2': 'ข้อมูลผู้เข้าพัก',
  'checkout-step3': 'ช่องทางชำระเงิน',

  'checkout-1-booking-details': 'รายละเอียดการจอง',
  'checkout-1-view-map': 'ดูแผนที่',
  'checkout-1-checkin': 'เช็คอิน',
  'checkout-1-checkout': 'เช็คเอาท์',
  'checkout-1-from': 'ตั้งแต่',
  'checkout-1-until': 'จนถึง',
  'checkout-1-period': 'ระยะเวลาเข้าพัก',
  'checkout-1-night-unit': 'คืน',
  'checkout-1-room-amount': 'จำนวนห้องและผู้เข้าพัก',
  'checkout-1-room-unit': 'ห้อง',
  'checkout-1-guest-amount': 'ผู้เข้าพักสูงสุดทั้งหมด',
  'checkout-1-adult-title': 'ผู้ใหญ่ {X} คน',
  'checkout-1-child-title': 'เด็ก {X} คน',
  'checkout-1-children-title': 'เด็ก {X} คน',
  'checkout-1-ages': 'อายุ',
  'checkout-1-and': 'และ',
  'checkout-1-year': ' ปี',
  'checkout-1-max-adult-title': 'ผู้ใหญ่ {X} คน',
  'checkout-1-max-child-title': 'เด็ก {X} คน',
  'checkout-1-max-children-title': 'เด็ก {X} คน',
  'checkout-1-room-detail-max-guest': 'ผู้เข้าพักสูงสุด',
  'checkout-1-adult': 'ผู้ใหญ่',
  'checkout-1-child': 'เด็ก',
  'checkout-1-room-detail': 'รายละเอียดห้องพัก',
  'checkout-1-room-type': 'ประเภทห้องพัก',
  'checkout-1-price-per-night': 'ราคาต่อคืน',
  'checkout-1-night': 'ระยะเวลาเข้าพัก',
  'checkout-1-room': 'จำนวนห้อง',
  'checkout-1-total': 'ยอดรวม',
  'checkout-1-note': 'หมายเหตุ',
  'checkout-1-max-adult': 'ผู้ใหญ่เข้าพักสูงสุด {X} คน',
  'checkout-1-max-child': 'เด็กเข้าพักสูงสุด {X} คน',
  'checkout-1-extrbed': 'รวมเตียงเสริม {X} เตียง',
  'checkout-1-description': 'ข้อมูลที่ควรทราบ',
  'checkout-1-bed-type-available': '(ขึ้นกับความพร้อมของที่พัก)',

  //checkout 2
  'checkout-2-booker-information-title': 'ข้อมูลผู้จอง',
  'checkout-2-guest-information-title': 'ข้อมูลผู้เข้าพัก',
  'checkout-2-topic-title': 'วัตถุประสงค์ในการเดินทาง',
  'checkout-2-booker-name-title': 'ชื่อผู้จอง',
  'checkout-2-booker-name-title-more': '(กรุณาใส่ข้อมูลเป็นอักษรภาษาอังกฤษ เท่านั้น)',
  'checkout-2-form-firstname-title': 'ชื่อ',
  'checkout-2-form-lastname-title': 'นามสกุล',
  'checkout-2-form-full-name-title': 'ชื่อผู้เข้าพักคน',
  'checkout-2-form-email-title': 'อีเมล',
  'checkout-2-form-number-title': 'เบอร์ติดต่อ',
  'checkout-2-form-nationality-title': 'สัญชาติ',
  'checkout-2-button-add-guest': 'เพิ่มรายชื่อผู้เข้าพัก',
  'checkout-2-button-display-more-details': 'เพิ่มคำขอพิเศษ',
  'checkout-2-button-display-hide-details': 'ซ่อนคำขอพิเศษ',
  'checkout-2-room-number-title': 'ห้อง',
  'checkout-2-guest-number-title': 'ชื่อผู้เข้าพักคนที่',
  'checkout-2-guest-number-title-without-index': 'ชื่อผู้เข้าพัก',
  'checkout-2-button-delete-guest': 'ลบผู้เข้าพัก',
  'checkout-2-special-request-title': 'คำขอพิเศษ',
  'checkout-2-special-request-title-eng-only': 'คำขอพิเศษ (กรุณาใส่ข้อมูลเป็นอักษรภาษาอังกฤษ เท่านั้น)',
  'checkout-2-special-request-english-only': 'คำขอพิเศษต้องเป็นภาษาอังกฤษเท่านั้น',
  'checkout-2-special-request-legend': 'เราจะส่งคำขอของคุณให้ที่พักทราบทันทีหลังจากที่จอง ไม่สามารถรับประกันการให้บริการตามคำขอได้ แต่ที่พักจะดำเนินการอย่างสุดความสามารถเพื่อความประสงค์ของคุณ และอาจมีค่าใช้จ่ายเพิ่มเติม',
  'checkout-2-form-require-full-name': 'กรุณาระบุชื่อและนามสกุลของคุณ',
  'checkout-2-form-invalid-full-name': 'กรุณาระบุชื่อและนามสกุลของคุณเป็นภาษาอังกฤษเท่านั้น',
  'checkout-2-form-require-firstname': 'กรุณาระบุชื่อของคุณ',
  'checkout-2-form-require-lastname': 'กรุณาระบุนามสกุลของคุณ',
  'checkout-2-form-invalid-firstname': 'กรุณาระบุชื่อของคุณเป็นภาษาอังกฤษเท่านั้น',
  'checkout-2-form-invalid-lastname': 'กรุณาระบุนามสกุลของคุณเป็นภาษาอังกฤษเท่านั้น',
  'checkout-2-form-require-mobile-number': 'กรุณาระบุเบอร์ติดต่อของคุณ',
  'checkout-2-form-invalid-mobile-number': 'กรุณาระบุเบอร์ติดต่อที่ถูกต้อง',
  'checkout-2-form-require-booker-email': `กรุณาระบุอีเมลของคุณ`,
  'checkout-2-form-invalid-booker-email': `อีเมลของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง`,
  'checkout-2-form-require-guest-firstname': 'กรุณาระบุชื่อผู้เข้าพัก',
  'checkout-2-form-require-guest-lastname': 'กรุณาระบุนามสกุลผู้เข้าพัก',
  'checkout-2-form-require-guest-full-name': 'กรุณาระบุชื่อและนามสกุลของผู้เข้าพัก',
  'checkout-2-form-require-guest-email': 'กรุณาระบุอีเมลของผู้เข้าพัก',
  'checkout-2-form-require-guest-nationality': 'กรุณาระบุสัญชาติของผู้เข้าพัก',
  'checkout-2-form-invalid-guest-firstname': 'ชื่อผู้เข้าพักต้องเป็นภาษาอังกฤษเท่านั้น',
  'checkout-2-form-invalid-guest-lastname': 'นามสกุลผู้เข้าพักต้องเป็นภาษาอังกฤษเท่านั้น',
  'checkout-2-form-invalid-guest-email': 'อีเมลของผู้เข้าพักไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'checkout-2-autocomplete-remove-guest': 'ลบข้อมูล',
  'checkout-2-save-new-guest': 'บันทึกข้อมูลเข้าในรายชื่อผู้เข้าพัก',
  'checkout-2-tooltips-save-new-guest': 'คุณสามารถบันทึกข้อมูลผู้เข้าพักได้สูงสุด 50 คน',
  'checkout-2-form-hint-full-name': 'ตามที่ปรากฏในหนังสือเดินทาง/เอกสารประจำตัวที่หน่วยงานราชการออกให้ (ไม่ต้องระบุคำนำหน้า/ตัวอักษรพิเศษ)',
  'checkout-2-form-full-name-placeholder': 'ชื่อ-นามสกุลภาษาอังกฤษ',
  'checkout-2-attach-file-upload-fail': 'อัพโหลดไฟล์ไม่สำเร็จ',
  'checkout-2-attach-file-upload-fail-press-try-again': 'กรุณาลองใหม่',
  'checkout-2-send-email-and-sms-traveller': 'เราจะส่งรายละเอียดการจองไปให้ทางอีเมลและเบอร์ติดต่อที่คุณระบุ',
  'checkout-2-send-email-and-sms-booker': 'เราจะส่งรายละเอียดการจองไปให้ทางอีเมลและเบอร์ติดต่อของคุณ',
  'checkout-2-arrival-time-title': 'เวลาเดินทางไปถึงที่พัก',
  'checkout-2-arrival-time-check-in': 'เวลาเช็คอิน:',
  'checkout-2-arrival-time-description': 'เพื่อให้แน่ใจว่าคุณจะได้รับความสะดวกและเช็คอินอย่างราบรื่นไร้ปัญหา โปรดแจ้งเวลาเช็คอินโดยประมาณให้ที่พักทราบล่วงหน้า',
  'checkout-2-arrival-time-property-local-time': 'เวลาท้องถิ่นของที่พัก',
  'checkout-2-booker-for-other-employee-title': 'จองให้พนักงานในบริษัท',
  'checkout-2-booker-for-other-employee-sub-title': 'กรุณาทำเครื่องหมายในช่องเพื่อเชื่อมต่อดึงข้อมูลพนักงาน',
  'checkout-2-addtional-traveller-field-place-holder': 'พิมพ์',
  'checkout-2-full-name-invalid-not-exist-company': 'ชื่อผู้เข้าพักไม่อยู่ในบริษัทของคุณ กรุณาตรวจสอบอีกครั้ง',
  'checkout-2-full-name-invalid-duplicate': 'ผู้เข้าพักนี้ถูกเลือกไปแล้ว กรุณาตรวจสอบใหม่อีกครั้ง',
  'checkout-2-full-name-invalid-credit-terms-off': 'ผู้เข้าพักไม่มีสิทธิ์ใช้งบประมาณบริษัท',
  'checkout-2-full-name-invalid-over-lap': 'ผู้เข้าพักมีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
  'checkout-2-full-name-invalid-restrict': 'ผู้เข้าพักนี้ไม่สามารถจองที่พักในจุดหมายปลายทางที่เลือกได้ เนื่องจากข้อจำกัดของบริษัท',
  'checkout-2-full-name-invalid-no-approval': 'ผู้เข้าพักไม่มีอีเมลผู้บังคับบัญชา กรุณาติดต่อ Call Center +66(0)2-020-2351 เพื่อตรวจสอบข้อมูล',
  'checkout-2-full-name-invalid-no-full-name': 'ผู้เข้าพักไม่มีข้อมูล ชื่อ-นามสกุล กรุณาติดต่อ Call Center +66(0)2-020-2351 เพื่อตรวจสอบข้อมูล',
  'checkout-2-over-budget-travel-policy': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ เนื่องจากมีวงเงินพิเศษในจุดหมายปลายทางที่เลือก {budget} บาท ต่อห้องต่อคืน',
  'checkout-2-over-budget': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ เนื่องจากมีวงเงิน {budget} บาท ต่อห้องต่อคืน',
  'checkout-2-over-co-budget': 'วงเงินต่อคืนของผู้เข้าพักไม่พอ เนื่องจากมีการจำกัดวงเงินในการจองห้องพักสำหรับผู้เข้าพัก 2 คน {budget} บาท ต่อห้องต่อคืน',

  // checkout 3
  'checkout-3-tooltip-label-diff': 'ต่างกันอย่างไร ?',
  'checkout-3-tooltip-label-work': 'ทำงาน',
  'checkout-3-tooltip-label-leisure': 'ท่องเที่ยว',
  'checkout-3-tooltip-desc-work': 'จองทริปทำงานสำหรับผู้เดินทางติดต่อธุรกิจได้อย่างง่ายดาย',
  'checkout-3-tooltip-desc-leisure': 'ค้นหาที่พักยอดเยี่ยมสำหรับทริปทุกรูปแบบ โดยการจองดังกล่าวจะไม่เชื่อมโยงกับบัญชีของบริษัท',

  'checkout-3-label-custom-payment-paynow-topic': 'เลือกวันชำระเงิน',
  'checkout-3-label-select-payment-method': 'เลือกช่องทางชำระเงิน ',
  'checkout-3-label-custom-payment-paynow': 'ชำระเงินทันที',
  'checkout-3-label-custom-payment-paylater': 'ชำระเงินภายหลัง',
  'checkout-3-label-custom-payment-paylater-sub-title': 'จองวันนี้ จะตัดเงินวันที่ ',
  'checkout-3-label-credit-card-infomation': 'กรอกข้อมูลบัตรเครดิต/เดบิต',
  'checkout-3-label-tax-invoice-infomation': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-month': 'เดือน',
  'checkout-3-label-year': 'ปี',
  'checkout-3-label-card-number': 'หมายเลขบัตรเครดิต/เดบิต',
  'checkout-3-label-card-name': 'ชื่อบนบัตร',
  'checkout-3-label-card-expire-date': 'วันหมดอายุ',
  'checkout-3-label-card-cvv': 'รหัสหลังบัตร',
  'checkout-3-label-book-now': 'จองวันนี้',
  'checkout-3-label-pay-on': 'รายการชำระเงินด้วยบัตรเครดิต/เดบิต',
  'checkout-3-label-valid-until': 'บัตรเครดิตของคุณต้องมีอายุถึงเดือน',
  'checkout-3-label-payment-detail': 'รายการชำระเงิน',
  'checkout-3-label-payment-multi-detail': 'รายการชำระเงิน',
  'checkout-3-label-payment-added-credit-card': 'รายการชำระเงินเพิ่มด้วยบัตรเครดิต/เดบิต',
  'checkout-3-label-payment-added-pay-on': 'ชำระเงินเพิ่มด้วยบัตรเครดิต/เดบิต',
  'checkout-3-label-payment-will-be': 'จะตัดเงินวันที่',

  'checkout-3-label-payment-tax-description-credit-term': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-payment-tax-description': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-payment-credit-terms-tax-info': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้',
  'checkout-3-label-payment-credit-terms-tax-info-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ของคุณ',
  'checkout-3-label-payment-credit-terms-tax-info-co-booker': 'สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ของผู้ร่วมเดินทาง',
  'checkout-3-label-payment-credit-card-tax-info': 'สำหรับการชำระเงินผ่านบัตรเครดิต/เดบิต',
  'checkout-3-label-payment-true-money-tax-info': 'สำหรับการชำระเงินผ่านทรูมันนี่ วอลเล็ท',
  'checkout-3-label-payment-tax-description-true-money': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-payment-qr-code-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-payment-e-wallet-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-payment-pay-at-counter-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'checkout-3-label-payment-im-banking-tax-info': 'ข้อมูลสำหรับออกใบกำกับภาษี/ใบเสร็จ',

  'checkout-3-label-multi-payment-info-edit-budget': 'แก้ไขวงเงิน',
  'checkout-3-label-multi-payment-main-info': 'ชำระเงิน',
  'checkout-3-label-multi-payment-extra-info': 'ชำระเงินเพิ่มด้วย',
  'checkout-3-label-multi-payment-info-credit-card': 'บัตรเครดิต/เดบิต',
  'checkout-3-label-multi-payment-info-true-money': 'ทรูมันนี่ วอลเล็ท',
  'checkout-3-label-multi-payment-info-personal-fleet': 'ด้วยบัตรฟลีทส่วนตัว',
  'checkout-3-label-multi-payment-info-personal-fleet-additional': 'บัตรฟลีทส่วนตัว',
  'checkout-3-label-multi-payment-info-corporate-fleet': 'ด้วยบัตรฟลีทบริษัท',
  'checkout-3-label-multi-payment-info-credit-terms': 'แบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
  'checkout-3-label-multi-payment-change-payment': 'เปลี่ยนช่องทาง',
  'checkout-3-label-night': 'คืน',
  'checkout-3-label-dot': '',
  'checkout-3-label-multi-payment-info-budget-not-found': 'คุณมีวงเงินในการจองที่พักจำกัดหรือไม่?',
  'checkout-3-label-multi-payment-info-add-budget': 'ระบุวงเงินของคุณ',
  'checkout-3-label-multi-payment-info-reset': 'เปลี่ยนกลับไปใช้ค่าตั้งต้น',
  'checkout-3-label-multi-payment-info-not-reach-grand-total': 'ยอดชำระขั้นต่ำ THB',
  'checkout-3-label-multi-payment-info-exceed-total-price': 'ยอดชำระเกินยอดรวมสุทธิ สามารถใส่ได้สูงสุด THB',

  'checkout-3-label-multi-payment-info-exceed-budget-limit': 'ยอดชำระเกินวงเงินที่คุณได้รับ สามารถใส่ได้สูงสุด THB',
  'checkout-3-label-multi-payment-info-exceed-budget-remaining': 'ยอดชำระเกินวงเงินที่คุณเหลืออยู่ สามารถใส่ได้สูงสุด THB',
  'checkout-3-label-multi-payment-share-budget-least-booker': 'ยอดชำระขั้นต่ำของคุณ THB',
  'checkout-3-label-multi-payment-info-exceed-budget-limit-co-booker': 'ยอดชำระเกินวงเงินที่ผู้ร่วมเดินทางได้รับ สามารถใส่ได้สูงสุด THB',
  'checkout-3-label-multi-payment-info-exceed-budget-remaining-co-booker': 'ยอดชำระเกินวงเงินที่ผู้ร่วมเดินทางเหลืออยู่ สามารถใส่ได้สูงสุด THB',
  'checkout-3-label-multi-payment-share-budget-least-co-booker': 'ยอดชำระขั้นต่ำของผู้ร่วมเดินทาง THB',
  'checkout-3-label-multi-payment-exceed-fleet-card': 'ยอดชำระเกินยอดคงเหลือในบัตรสามารถใส่ได้สูงสุด THB',

  'checkout-3-label-credit-terms-info-title': 'ข้อมูลการส่งใบแจ้งหนี้ของคุณ',
  'checkout-3-label-credit-terms-info-title-co-booker': 'ข้อมูลการส่งใบแจ้งหนี้ของผู้ร่วมเดินทาง',
  'checkout-3-label-credit-terms-info-desc': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของคุณ ตามรอบบิลที่ได้ทำการตกลงกันไว้',
  'checkout-3-label-credit-terms-info-desc-co-booker': 'เราจะทำการส่งใบแจ้งหนี้สำหรับการจองห้องพักไปยังบริษัทของผู้ร่วมเดินทาง ตามรอบบิลที่ได้ทำการตกลงกันไว้',
  'checkout-3-label-credit-card-info-title': 'ข้อมูลบัตรเครดิต/เดบิต',
  'checkout-3-label-credit-terms-info-co-booker-email': 'ผู้ร่วมเดินทาง :',

  'checkout-3-label-credit-terms-info-traveller-title': 'ข้อมูลการส่งใบแจ้งหนี้ของผู้เข้าพักคนที่',
  'checkout-3-label-credit-terms-info-traveller-email': 'ผู้เข้าพักคนที่',

  'checkout-3-label-desc-credit-term': 'คุณเลือกการชำระเงินแบบวางบิล',
  'checkout-3-label-sub-desc-credit-term': 'เราจะทำการเรียกเก็บเงินไปยังบริษัทของคุณตามระยะเวลาที่ได้ทำการตกลงไว้',
  'checkout-3-label-fund-code': 'หมายเลขอ้างอิงในบริษัท (ถ้ามี)',
  'checkout-3-label-cost-center': 'Cost Center',
  'checkout-3-label-set-default': 'ใช้ Cost Center ของคุณ',
  'checkout-3-label-cost-center-name': 'Cost Center Name',
  'checkout-3-placeholder-cost-center': 'พิมพ์ Cost Center ที่นี่',
  'checkout-3-placeholder-cost-center-name': 'พิมพ์ Cost Center Name ที่นี่',
  'checkout-3-form-cost-center-required': 'กรุณาระบุ ',
  'checkout-3-form-cost-center-name-required': 'กรุณาระบุ ',
  'checkout-3-form-cost-center-name-invalid': '{text} ไม่ถูกต้อง กรุณาระบุ {text} ใหม่อีกครั้ง',
  'checkout-3-label-cost-center-dropdown': 'กรุณาเลือก ',
  'checkout-3-label-internal-order-dropdown': 'กรุณาเลือก ',
  'checkout-3-form-dropdown-placeholder': 'เลือก',
  'checkout-3-form-dropdown-required': 'กรุณาเลือก',
  'checkout-3-form-free-text-placeholder': 'พิมพ์',
  'checkout-3-form-free-text-required': 'กรุณาระบุ',
  'checkout-3-form-attachment-required': 'กรุณาแนบไฟล์',

  'checkout-3-placeholder-card-number': '●●●● ●●●● ●●●● ●●●●',
  'checkout-3-placeholder-card-name': 'ชื่อบนบัตร',
  'checkout-3-placeholder-card-cvv': 'รหัส CVC/CVV',
  'checkout-3-placeholder-fund-code': 'พิมพ์หมายเลขอ้างอิงในบริษัทที่นี่',
  'checkout-3-placeholder-expire-date': 'ดด/ปป',

  'checkout-3-form-require-card-number': 'กรุณาระบุหมายเลขบัตร',
  'checkout-3-form-invalid-card-number': 'คุณกรอกหมายเลขบัตรไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'checkout-3-form-invalid-card-number-not-support': 'ไม่สามารถใช้บัตรนี้ในการชำระเงินได้',
  'checkout-3-form-require-card-name': 'กรุณาระบุชื่อบนบัตร',
  'checkout-3-form-invalid-card-name': 'ชื่อบนบัตรต้องเป็นภาษาอังกฤษเท่านั้น',
  'checkout-3-form-require-card-cvv': 'กรุณาระบุรหัสหลังบัตร',
  'checkout-3-form-invalid-card-cvv': 'คุณกรอกรหัสหลังบัตรไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'checkout-3-form-require-card-exp-date': 'กรุณาระบุวันหมดอายุบัตร',
  'checkout-3-form-invalid-card-exp-date': 'วันหมดอายุของบัตรไม่ถูกต้อง',
  'checkout-3-form-invalid-card-expire-pay-on': 'ไม่สามารถใช้บัตรนี้ได้เนื่องจากบัตรจะหมดอายุก่อนวันตัดเงิน',
  'checkout-3-require-tax-address': 'กรุณาเลือกข้อมูลสำหรับออกใบกำกับภาษี หรือ ใบเสร็จ',

  'checkout-3-error-cannot-create-booking': 'รายการสั่งจองของคุณทำรายการไม่สำเร็จ<br/>กรุณาทำรายการใหม่อีกครั้ง',
  'checkout-3-error-limit-room': 'วงเงินการจองของคุณมีการเปลี่ยนแปลง<br/>กรุณาตรวจสอบและทำรายการใหม่อีกครั้ง',
  'checkout-3-error-limit-budget': 'สิทธิ์การจองของคุณมีการเปลี่ยนแปลง<br/>กรุณาตรวจสอบและทำรายการใหม่อีกครั้ง',
  'checkout-3-address-edit-failure-title': 'ไม่สามารถอัพเดตข้อมูลได้',
  'checkout-3-error-cannot-get-dropdown-list': 'ไม่สามารถดึงข้อมูลใบกำกับภาษีได้.',
  'checkout-3-default-dropdown': 'กรุณาเลือก',
  'checkout-3-error-supervisor-email-invalid': 'คุณไม่สามารถจองที่พักได้ กรุณาติดต่อ Call Center เพื่อตรวจสอบอีเมลผู้บังคับบัญชาของคุณ<br/>Call center : +66(0) 2-020-2351',
  'checkout-3-error-credit-term-not-allow': 'คุณไม่มีสิทธิ์ในการจองห้องพักแบบส่งใบแจ้งหนี้ (Credit Terms) กรุณาติดต่อ Call Center เพื่อตรวจสอบข้อมูล <br/> Call center: +66(0) 2-020-2351',
  'checkout-3-error-multi-payment-not-allow': 'คุณไม่มีสิทธิ์ในการจองห้องพักเกินงบประมาณ กรุณาติดต่อ Call Center เพื่อตรวจสอบข้อมูลเพิ่มเติม <br/> Call center: +66(0) 2-020-2351',
  'checkout-3-error-credit-term-over-trip-budget': 'ยอดชำระเงินแบบส่งใบแจ้งหนี้เกินงบประมาณที่ขออนุมัติ<br>งบประมาณที่ขออนุมัติคือ THB {totalTripBudget}<br>กรุณาปรับยอดชำระเงินหรือเลือกที่พักใหม่อีกครั้ง',

  'checkout-3-true-money-title': 'ข้อมูลบัญชี',
  'checkout-3-true-money-payment': 'ชำระเงินผ่านบัญชีทรูมันนี่',
  'checkout-3-true-money-payment-recheck': 'กรุณาตรวจสอบยอดเงินคงเหลือเพียงพอก่อนการใช้',
  'checkout-3-true-money-phone-no': 'เบอร์โทรศัพท์ที่ผูกกับทรูมันนี่ วอลเล็ท',
  'checkout-3-true-money-phone-no-empty': 'กรุณาระบุเบอร์โทรศัพท์',
  'checkout-3-true-money-phone-pattern': 'เบอร์โทรศัพท์ไม่ถูกต้อง',
  'checkout-3-true-money-box-text-1': 'ชำระเงินผ่านบัญชีทรูมันนี่ วอลเล็ท',
  'checkout-3-true-money-box-text-2': ' จะตัดเงินวันที่',
  'checkout-3-true-money-true-point-short': 'ทุกการใช้จ่าย 25 บาท รับ 1 ทรูพอยท์',
  'checkout-3-require-payment-method': 'กรุณาเลือกช่องทางการชำระเงิน',
  'checkout-3-true-money-note': 'หมายเหตุ',
  'checkout-3-true-money-note-0': 'มูลค่าชำระทุก 25 บาท สำหรับการชำระเงินด้วย ทรูมันนี่ วอลเล็ท ได้รับ 1 ทรูพอยท์ ต่อ 1 รายการ ต่อ 1 หมายเลขบัตรประชาชน',
  'checkout-3-true-money-note-1': 'ลูกค้าจะได้รับทรูพอยท์ ภายใน 30 วันทำการหลังจากสั่งสินค้าผ่าน https://traveltogether.ascendtravel.com และจ่ายด้วย ทรูมันนี่ วอลเล็ท โดยจำกัดสิทธิ์ 100 ทรูพอยท์ / 1 บัตรประชาชน ตลอดระยะเวลาแคมเปญ',
  'checkout-3-true-money-note-2': 'รายการส่งเสริมการขายนี้ ดำเนินการโดยบริษัท ทรูมันนี่ จำกัด',
  'checkout-3-true-money-note-3': 'หากมีข้อสงสัย กรุณาติดต่อ TrueMoney Customer Care 1242 ตลอด 24 ชั่วโมง',
  'checkout-3-label-main-payment': 'ช่องทางหลัก',
  'checkout-3-label-additional-payment': 'ช่องทางชำระเงินเพิ่ม',
  'checkout-3-label-place-holder-payment': 'กรุณาเลือกช่องทางการชำระเงิน...',
  'checkout-3-label-additional-payment-error': 'กรุณาเลือกช่องทางการชำระเงิน',
  'checkout-3-label-approximate-price-in': 'ราคาโดยประมาณสกุลเงิน',

  'checkout-3-qr-code-title': 'QR Code',
  'checkout-3-e-wallet-title': 'E-Wallet',
  'checkout-3-im-banking-title': 'ธนาคารออนไลน์',
  'checkout-3-im-banking-payment-channel': 'โมบายแบงก์กิ้ง / อินเตอร์เนตแบงก์กิ้ง',
  'checkout-3-pay-at-counter-title': 'เงินสดผ่านเคาน์เตอร์',
  'checkout-3-pay-at-counter-bank-counter': 'เคาน์เตอร์ธนาคาร',
  'checkout-3-pay-at-counter-other-counter': 'เคาน์เตอร์ชำระเงินต่างๆ',

  'checkout-3-payment-method-line1': 'เราจะแจ้งวิธีชำระเงินในหน้าถัดไป',
  'checkout-3-payment-method-line2': 'กรุณาชำระเงินให้เสร็จสมบูรณ์ภายใน 15 นาที เพื่อไม่ให้การจองของท่านถูกยกเลิก',
  'checkout-3-payment-method-line2-30': 'กรุณาชำระเงินให้เสร็จสมบูรณ์ภายใน 30 นาที เพื่อไม่ให้การจองของท่านถูกยกเลิก',
  'checkout-3-payment-method-line3-2c2p': 'การชำระเงินให้กับแอสเซนด์ แทรเวิล ดำเนินการโดยบริการ 2C2P (2C2P SERVICE)',
  'checkout-3-payment-method-line3-123': 'การชำระเงินให้กับแอสเซนด์ แทรเวิล ดำเนินการโดยบริการ 123 (123 SERVICE)',

  'checkout-3-payment-method-remark-line1': 'อาจมีการเรียกเก็บค่าบริการเพิ่มเติมเมื่อคุณชำระเงินที่เคาน์เตอร์ (ค่าบริการเพิ่มเติมไม่สามารถขอคืนเงินได้)',
  'checkout-3-payment-method-remark-line2': 'หลังจากทำการชำระเงินเสร็จ คุณจะได้รับอีเมลยืนยันการจองห้องพักภายใน 2 ชั่วโมง หากท่านไม่ได้รับอีเมลในเวลาที่กำหนด กรุณาติดต่อ',
  'checkout-3-payment-method-remark-line2-call-center': 'Call Center : +66(0) 2-020-2351',
  'checkout-3-payment-method-remark-line2-or': 'หรือ',
  'checkout-3-payment-method-remark-line2-line': 'Line Official Account : @AscendTravel',

  'checkout-3-warning-please-make-payment': 'กรุณาชำระเงินภายใน 15 นาที',
  'checkout-3-warning-please-make-payment-30': 'กรุณาชำระเงินภายใน 30 นาที',
  'checkout-3-warning-avoid-cancellation': 'เพื่อไม่ให้รายการจองของคุณถูกยกเลิก',
  'checkout-3-warning-press': 'กด',
  'checkout-3-warning-confirm-to-book': '"ยืนยันการจอง"',
  'checkout-3-warning-to-proceed': 'เพื่อดำเนินการต่อ',

  'checkout-3-payment-channel': 'ช่องทางการชำระเงิน',
  'checkout-3-payment-method': 'วิธีชำระเงิน',
  'checkout-3-payment-method-remark-title': 'หมายเหตุ',

  // billing address component
  'checkout-3-label-billing-infomation': 'ข้อมูลสำหรับวางบิล',
  'checkout-3-billing-address-name': 'ชื่อผู้รับวางบิล',
  'checkout-3-billing-address-name-placeholder': 'พิมพ์ ชื่อ-นามสกุล ของผู้รับวางบิลที่นี่',
  'checkout-3-billing-address-phone': 'เบอร์ติดต่อผู้รับวางบิล',
  'checkout-3-billing-address-phone-placeholder': '0XXXXXXXXX',
  'checkout-3-billing-address-address': 'ที่อยู่สำหรับวางบิล',
  'checkout-3-billing-address-address-address-placeholder': 'พิมพ์ที่อยู่สำหรับวางบิลที่นี่',

  'checkout-3-billing-validation-required-name': 'กรุณาระบุชื่อผู้รับวางบิล',
  'checkout-3-billing-validation-required-phone': 'กรุณาระบุเบอร์ติดต่อผู้รับวางบิล',
  'checkout-3-billing-validation-required-address': 'กรุณาระบุที่อยู่สำหรับวางบิล',
  'checkout-3-billing-validation-invalid-name': 'ชื่อผู้รับวางบิลจะต้องเป็นตัวอักษร a-z A-Z',
  'checkout-3-billing-validation-invalid-phone': 'เบอร์ติดต่อต้องเป็นตัวเลข 0-9 จำนวน 9 หรือ 10 หลักเท่านั้น',
  'checkout-3-billing-validation-invalid-address': 'กรุณาระบุที่อยู่สำหรับวางบิล',

  'checkout-3-require-internal-order': 'กรุณาระบุ',
  'checkout-3-require-billing-address': 'กรุณาเลือกข้อมูลสำหรับวางบิล',
  'checkout-3-billing-dialog-delete-button': 'ลบ',
  'checkout-3-billing-delete-success': 'ลบเรียบร้อยแล้ว',
  'checkout-3-billing-delete-failure': 'ลบไม่สำเร็จ',
  'checkout-3-billing-failure-text-try-again': 'กรุณาลองใหม่อีกครั้ง',
  'checkout-3-billing-add': 'ที่อยุ่สำหรับวางบิลที่เพิ่ม',
  'checkout-3-billing-edit': 'ที่อยุ่สำหรับวางบิลที่แก้ไข',
  'checkout-3-billing-confirm-delete-msg': 'คุณต้องการลบข้อมูลนี้?',
  'checkout-3-billing-confirm-cancel-editing': 'คุณยังไม่ได้ทำการบันทึก{dataType} ต้องการออกจากหน้านี้โดยไม่บันทึกใช่หรือไม่?',

  'checkout-3-attach-file-title': 'แนบไฟล์',
  'checkout-3-attach-file-choose-button': 'แนบไฟล์',
  'checkout-3-attach-file-guide': 'สามารถแนบไฟล์สูงสุด 5 ไฟล์ และรองรับไฟล์ .jpg, .pdf, .png, .msg, .eml ขนาดไม่เกิน 2 MB เท่านั้น',

  'checkout-3-attach-file-validation-invalid-file-type': 'ไม่รองรับประเภทไฟล์ที่คุณแนบมา คุณสามารถแนบไฟล์ .jpg, .pdf, .png, .msg, .eml ได้เท่านั้น',
  'checkout-3-attach-file-validation-file-size-overflow': 'ไฟล์แนบมีขนาดเกินกว่าที่กำหนดไว้ คุณสามารถแนบไฟล์ขนาดไม่เกิน 2 MB เท่านั้น',
  'checkout-3-attach-file-validation-file-not-attached': 'กรุณาเลือกไฟล์',

  'search-popup-checkbox-label': 'ไม่ต้องแสดงข้อความนี้อีก',
  'popup-warning-session-expire': 'การใช้งานของคุณกำลังจะหมดอายุ<br/>กรุณากด ตกลง เพื่อต่ออายุการใช้งานอีกครั้ง',

  // Approval action
  'approval-action-success-approve': 'การจองได้รับการอนุมัติและดำเนินการเรียบร้อยแล้ว',
  'approval-action-success-reject': 'รายการจองถูกยกเลิกเรียบร้อยแล้ว',
  'approval-action-after-done': 'ไม่สามารถอนุมัติ/ปฏิเสธการจองได้',
  'approval-action-after-done-desc': 'เนื่องจากคุณได้ทำการอนุมัติ/ปฏิเสธการจองหรือเลยวันเข้าพักแล้ว',
  'approval-action-after-cancel': 'ไม่สามารถอนุมัติ/ปฏิเสธการจองได้',
  'approval-action-after-cancel-desc': 'เนื่องจากผู้จองยกเลิกการจองแล้ว',
  'approval-action-fail-service': 'ทำรายการไม่สำเร็จ',
  'approval-action-fail-service-desc': 'กรุณาลองใหม่อีกครั้ง',
  'approval-action-thankyou-1': 'ขอขอบคุณที่ให้ความไว้วางใจในการใช้บริการกับ Ascend Travel',
  'approval-action-thankyou-2': 'ติดต่อสอบถาม Call Center +66(0) 2-020-2351',
  'approval-action-btn-home': 'ไปหน้าหลัก',
  'approval-action-btn-approval-list': 'ตรวจสอบรายการอนุมัติ',
  'approval-action-unable-approval': 'ไม่สามารถอนุมัติหรือปฏิเสธการจองได้',
  'approval-action-unable-approval-detail': 'กรุณาตรวจสอบสถานะของรายการอนุมัติที่เมนู "รายการที่ต้องอนุมัติ"',
  'approval-action-unable-approval-or-reject-detail': 'ไม่สามารถอนุมัติหรือปฏิเสธรายการจองได้',
  'approval-cancellation-credit-card': 'ค่าธรรมเนียมการยกเลิกสำหรับการชำระเงินด้วยบัตรเครดิต/เดบิต',

  'notify_accept_terms_conditions': 'ฉันยอมรับเงื่อนไข / I accept those conditions.',
  'notify_accept_terms_conditions_validation_accept': 'กรุณายอมรับเงื่อนไข / Please accept terms and condition.',

  // Krung sri
  'notify_accept_terms_conditions_message_krungsri': 'ข้าพเจ้ารับทราบและตกลงว่า ในการจองที่พักเพื่อ “ทำงาน”  ข้าพเจ้าจะทำการแนบเอกสารที่ได้รับอนุมัติจากผู้มีอำนาจก่อนการจองที่พักทุกครั้ง และ Ascend Travel จะทำการเรียกเก็บเงินที่พักกับบริษัทที่ท่านสังกัด ทั้งนี้ ข้าพเจ้าตกลงและรับทราบว่าข้าพเจ้าจะต้องรับผิดชอบค่าใช้จ่ายด้วยตนเอง ภายใน 7 วันนับแต่วันที่บริษัทเรียกเก็บค่าใช้จ่ายหากข้าพเจ้าไม่เข้าพักโดยไม่มีเหตุผลอันสมควร ในกรณีการจองเพื่อ “ท่องเที่ยว” ข้าพเจ้าจะต้องทำการชำระเงินด้วยตนเอง',

  // Osotspa
  'notify_accept_terms_conditions_message_osotspa': 'ข้าพเจ้ารับทราบนโยบายการจองที่พัก และการปฏิบัติตามแนวทางที่บริษัทฯกำหนด ในการจองห้องพักทุกครั้ง',

  'rating-header': 'คุณมีความเห็นอย่างไรเกี่ยวกับ',
  'rating-check-in': 'เช็คอิน',
  'rating-check-out': 'เช็คเอาท์',
  'rating-star-1': 'แย่มาก',
  'rating-star-2': 'แย่',
  'rating-star-3': 'พอใจ',
  'rating-star-4': 'ดี',
  'rating-star-5': 'ดีมาก',
  'rating-submit': 'ส่งรีวิว',
  'rating-error-select-satisfaction': 'กรุณาเลือกระดับความพอใจ',
  'rating-message-thankyou': 'ขอบคุณสำหรับการรีวิว<br/>ความเห็นของคุณจะช่วยในการพัฒนาให้กับทางที่พัก รวมถึงช่วยผู้เข้าพักท่านอื่นในการตัดสินใจ',
  'rating-header-animal': 'คุณเจอสิ่งลี้ลับ หรือสัตว์ต่างๆเหล่านี้ไหม',
  'rating-summarize-header-1': 'หัวข้อความคิดเห็น',
  'rating-summarize-placeholder-1': 'คุณคิดอย่างไรกับการเข้าพักครั้งนี้',
  'rating-summarize-header-2': 'แสดงความคิดเห็น',
  'rating-summarize-placeholder-2': 'แชร์ประสบการณ์ การเข้าพักของคุณให้คนอื่นๆ',
  'rating-summarize-error': 'กรุณาระบุหัวข้อความคิดเห็น',
  'rating-img-error': 'ไฟล์ ขนาดเกิน 2 MB',
  'hide-name': 'ซ่อนชื่อของฉัน',
  'rating-photo-header': 'แชร์รูปที่พักให้คนอื่นๆได้ที่นี่',
  'rating-photo-subtitle': 'สามารถใส่ภาพได้สูงสุด 5 ภาพโดยไฟล์ต้องใช้นามสกุล .png, jpeg หรือ .jpg และขนาดไฟล์ที่แนบห้ามเกิน 2 MB',

  // Banner promotion
  'banner-topic': 'ข้อเสนอสุดพิเศษวันนี้',
  'banner-sub-topic': 'โปรโมชั่น ส่วนลด และข้อเสนอพิเศษสำหรับคุณโดยเฉพาะ',
  'banner-book-period': 'ระยะเวลาการจอง',
  'banner-stay-period': 'ช่วงเวลาเข้าพัก',
  'banner-btn-book': 'จอง',

  // Confirmation supplier
  'confirmation-supplier-email-reject': 'กรุณาระบุชื่อของคุณเพื่อแจ้งการปฏิเสธการจองห้องพักจาก Ascend Travel',
  'confirmation-supplier-email-confirm': 'กรุณาระบุชื่อของคุณเพื่อทำการยืนยันการจองห้องพักจาก Ascend Travel',
  'confirmation-supplier-email-confirm-title': 'ผู้ยืนยันการจอง',
  'confirmation-supplier-email-confirm-title-error': 'กรุณาระบุ ผู้ยืนยันการจอง',
  'confirmation-supplier-email-confirm-confirm-number': 'Confirmation Number (ถ้ามี)',
  'confirmation-supplier-email-reject-title': 'ผู้ปฏิเสธการจอง',
  'confirmation-supplier-email-reject-title-error': 'กรุณาระบุ ผู้ปฏิเสธการจอง',
  'confirmation-supplier-email-reject-reason': 'เหตุผล',
  'confirmation-supplier-email-reject-reason-error': 'กรุณาระบุ เหตุผล',
  'confirmation-supplier-email-reject-topic-title': 'กรุณาระบุชื่อของคุณเพื่อแจ้งการปฏิเสธการจองห้องพักจาก Ascend Travel',
  'confirmation-supplier-email-confirm-topic-title': 'กรุณาระบุชื่อของคุณเพื่อทำการยืนยันการจองห้องพักจาก Ascend Travel',
  'confirmation-supplier-email-confirm-status-success': 'คุณได้ทำการยืนยันการจองห้องพักจาก Ascend Travel เรียบร้อยแล้ว',
  'confirmation-supplier-email-reject-status-success': 'คุณได้ทำการปฏิเสธการจองห้องพักจาก Ascend Travel เรียบร้อยแล้ว',
  'confirmation-supplier-email-already': 'เนื่องจากคุณได้ทำการ ยืนยัน/ปฏิเสธ การจองเรียบร้อยแล้ว',
  'confirmation-supplier-email-placeholder-confirmed-by': 'ชื่อ/นามสกุล',
  'confirmation-supplier-email-placeholder-confirmation-number': 'Confirmation Number',
  'confirmation-supplier-email-placeholder-rejected-by': 'ชื่อ/นามสกุล',
  'confirmation-supplier-email-placeholder-reason': 'เหตุผลในการปฏิเสธ',

  // Promotion
  'promotion-promotion-code-title': 'Promotion Code',
  'promotion-promotion-code-error': 'กรุณาระบุ Promotion Code',
  'promotion-promotion-code-button-submit': 'ยืนยัน',
  'promotion-promotion-code-topic-title': 'กรุณากรอก Promotion Code',
  'promotion-promotion-code-error-invalid-message': 'Promotion code ไม่ถูกต้อง',
  'promotion-promotion-code-error-used-message': 'Promotion code นี้ถูกใช้ไปแล้ว',
  'promotion-thankyou-title1': 'หมายเลขการสั่งจอง ',
  'promotion-thankyou-title2': 'กำลังดำเนินการ',
  'promotion-thankyou-description': 'ระบบกำลังดำเนินการจองห้องพักให้กับคุณโดย คุณจะได้รับอีเมลยืนยันการจองอีกครั้ง',
  'promotion-promotion-code-error-invalid-link': 'Link นี้ได้ถูกยกเลิกจากระบบแล้ว',
  'promotion-promotion-code-error-use-full': 'ขออภัย Promotion Code นี้ มีผู้รับสิทธิ์เต็มจำนวนเรียบร้อยแล้ว',
  'promotion-thankyou-status-timeout-title': ' กรุณาติดต่อ Call Center เพื่อตรวจสอบรายการจอง',
  'promotion-thankyou-status-timeout-text': "เนื่องจากระบบขัดข้องระหว่างทำรายการ ติดต่อ Call Center +66 (0)2-020-2351",
  // Condition
  'condition-selling-price-in-budget-title': 'ราคาห้องพักมีการเปลี่ยนแปลงตามข้อมูลในตารางด้านล่าง',
  'condition-selling-price-over-budget': 'ราคาห้องพักเกินงบประมาณของคุณ',
  'condition-selling-price-in-budget-column': 'ประเภทห้องพัก,ราคาต่อคืนก่อนหน้า,ราคาต่อคืนใหม่',
  'condition-limit-room-title': 'คุณมีสิทธิ์ในการจองแค่เพียง ${var} ห้อง',
  'condition-cancellation-policy-title': 'เงื่อนไขการยกเลิกห้องพักมีการเปลี่ยนแปลงตามข้อมูลในตารางด้านล่าง',
  'condition-cancellation-policy-column': 'ประเภทห้องพัก,เงื่อนไขการยกเลิกห้องพักใหม่',
  'condition-cancellation-policy-baht': 'หากยกเลิกหลังวันที่ ${var} จะเสียค่าธรรมเนียมการยกเลิกห้องพัก THB ${var}',
  'condition-cancellation-policy-non-refundable': 'ไม่สามารถขอรับเงินคืน หากยกเลิิกการจอง',
  'condition-cancellation-policy-free-of-charge': 'ฟรี! ค่าธรรมเนียมการยกเลิก หากยกเลิกก่อนวันที่ ${var}',
  'condition-free-cancellation': 'ยกเลิกการจองฟรี',
  'condition-cancellation-policy-pay-now': 'เงื่อนไขการชำระเงินเปลี่ยนแปลง<br/> จากชำระเงินวันที่ ${var}<br/> เป็นชำระเงินวันนี้',
  'condition-cancellation-policy-pay-later': 'เงื่อนไขการชำระเงินเปลี่ยนแปลง<br/> จากชำระเงินวันนี้<br/> เป็นชำระเงินวันที่ ${var}',
  'condition-cancelltaion-policy-pay-later-from-to': 'เงื่อนไขการชำระเงินเปลี่ยนแปลง<br/> จากชำระเงินวันที่ ${var}<br/> เป็็นชำระเงินวันที่ ${var}',
  'condition-offer-type-title': 'รายละเอียดห้องพักมีการเปลี่ยนแปลงตามข้อมูลในตารางด้านล่าง',
  'condition-offer-type-column': 'ประเภทห้องพัก,รายละเอียดก่อนหน้า,รายละเอียดใหม่',
  'condition-no-available-room-title': 'ไม่มีห้องพักในช่วงวันที่คุณต้องการ',
  'condition-button-accept': 'ยอมรับ',
  'condition-button-back-to-search': 'กลับไปค้นหาใหม่',
  'condition-offer-type-breakfast-include': 'รวมอาหารเช้า',
  'condition-offer-type-breakfast-not-include': 'ไม่รวมอาหารเช้า',
  'condition-aad-userid-not-exist': 'User not found',
  'condition-user-not-active-or-not-approve': 'User is inactive',
  'condition-period-overlaps-title': 'คุณไม่สามารถจองที่พักได้',
  'condition-period-overlaps-description': 'เนื่องจากคุณมีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
  'condition-period-overlaps-share-budget-description': 'เนื่องจากคุณหรือผู้ร่วมเดินทางมีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
  'condition-restrict-destination-title': 'คุณไม่สามารถจองที่พักในจุดหมายปลายทางที่เลือกได้',
  'condition-restrict-destination-description': 'เนื่องจากเป็นเขตพื้นที่ปฏิบัติงานปกติของคุณ กรุณากดตกลงเพื่อกลับไปค้นหาใหม่',
  'condition-restrict-destination-co-booker-title': 'คุณไม่สามารถจองที่พักในจุดหมายปลายทางที่เลือกได้',
  'condition-restrict-destination-co-booker-description': 'เนื่องจากบริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้จองที่พักในจุดหมายปลายทางดังกล่าว กรุณากดตกลงเพื่อกลับไปค้นหาใหม่',
  'condition-some-guest-not-exist-in-your-comany': 'มีผู้เข้าพักที่ไม่อยู่ในบริษัทของคุณ',
  'condition-some-guest-not-allow-to-use-credit-terms': 'มีผู้เข้าพักที่ไม่มีสิทธิ์ใช้งบประมาณบริษัท',
  'condition-some-guest-already-have-a-booking-in-this-period': 'มีผู้เข้าพักที่มีรายการจองที่พักอื่นในช่วงเวลานี้ไปแล้ว',
  'condition-some-guest-has-no-supervisor-email': 'มีผู้เข้าพักที่ไม่มีอีเมลผู้บังคับบัญชา กรุณาติดต่อ Call Center +66(0)2-020-2351 เพื่อตรวจสอบ',

  // Mice
  'mice-quotation-title': 'ให้เราช่วยจัดหาบริการที่เหมาะกับคุณ',
  'mice-quotation-sub-title': 'กรุณาระบุข้อมูลของคุณเพื่อให้ทีมงานของเราเสนอราคาบริการที่คุณสนใจ และเราจะติดต่อคุณโดยเร็วที่สุดค่ะ',
  'mice-quotation-placeholder-dropdown': 'กรุณาเลือกบริการที่คุณสนใจ',
  'mice-quotation-destination': 'สถานที่/จุดหมายปลายทาง',
  'mice-quotation-start-date': 'วันที่เริ่มต้นใช้บริการ',
  'mice-quotation-end-date': 'วันที่สิ้นสุดบริการ',
  'mice-quotation-attendees': 'จำนวนคน (คน)',
  'mice-quotation-budget': 'งบประมาณ (บาท)',
  'mice-quotation-special-request': 'คำขอพิเศษ',
  'mice-quotation-contact-title': 'ข้อมูลติดต่อ',
  'mice-quotation-contact-name': 'ชื่อผู้ติดต่อ',
  'mice-quotation-contact-company': 'ติดต่อในนาม',
  'mice-quotation-contact-phone': '0XXXXXXXXX',
  'mice-quotation-contact-email': 'email@mail.com',
  'mice-quotation-description-service': 'หากคุณต้องการหลายบริการ คุณสามารถเลือกบริการหลัก และระบุบริการเสริมในช่องรายละเอียดเพิ่มเติม',
  'mice-quotation-description-date': 'หากคุณไม่สามารถระบุช่วงวันที่ได้ กรุณาระบุในช่องรายละเอียดเพิ่มเติม',
  'mice-quotation-warning-zero-budget': 'งบประมาณต้องมากกว่า 0 บาท',
  'mice-quotation-warning-zero-attendees': 'จำนวนคนต้องมากกว่า 0 คน',
  'mice-quotation-warning-placeholder-dropdown': 'กรุณาเลือกบริการที่คุณสนใจ',
  'mice-quotation-warning-contact-name': 'กรุณาระบุชื่อผู้ติดต่อ',
  'mice-quotation-warning-contact-company': 'กรุณาระบุชื่อบริษัทของคุณ',
  'mice-quotation-warning-contact-phone': 'กรุณาระบุเบอร์ติดต่อของคุณ',
  'mice-quotation-warning-contact-email': 'กรุณาระบุอีเมลของคุณ',
  'mice-quotation-button-submit': 'ส่งข้อมูล',
  'mice-quotation-popup-sent': 'ข้อมูลของคุณได้ถูกส่งไปยังทีมงานของเราแล้ว<br/> เราจะติดต่อกลับภายใน 1 วันทำการ',
  'mice-quotation-popup-fail': 'ขออภัยค่ะ ระบบขัดข้อง<br/> กรุณาลองใหม่อีกครั้ง',
  'mice-our-service-heading': 'บริการของเรา',
  'mice-our-service-seminar': 'จัดงานประชุมสัมมนา',
  'mice-our-service-seminar-sub-title': '(Seminar Management / MICE)',
  'mice-our-service-team-building': 'จัดกิจกรรมพัฒนาบุคคลากร',
  'mice-our-service-team-building-sub-title': '(Team Building / Camp Project / Rally)',
  'mice-our-service-group-tour': 'ทริปเดินทางในประเทศและต่างประเทศ',
  'mice-our-service-group-tour-sub-title': '(Group Tour / Incentive Group)',
  'mice-our-service-party': 'จัดงานเลี้ยงและงานพิธีต่างๆ',
  'mice-our-service-party-sub-title': '(Staff Party / Private Party / Merit-making Ceremony)',
  'mice-our-service-csr': 'จัดกิจกรรมสาธารณประโยชน์เพื่อสังคม',
  'mice-our-service-csr-sub-title': '(CSR Activity)',
  'mice-our-service-private-jet': 'บริการเช่าเครื่องบินส่วนตัว',
  'mice-our-service-private-jet-sub-title': '',
  'mice-our-service-car-rental': 'บริการรถเช่า',
  'mice-our-service-car-rental-sub-title': '',
  'mice-our-service-ticket': 'จองตั๋วเครื่องบิน<br/>และขอวีซ่าทั่วโลก',
  'mice-our-service-ticket-sub-title': '',
  'mice-benefit-title-easy': 'ง่าย',
  'mice-benefit-easy': 'กรอกข้อมูลทั้งหมด ทุกความต้องการไว้ที่เดียว',
  'mice-benefit-title-convenience': 'สะดวก',
  'mice-benefit-convenience': 'ทำรายการได้ทุกที่ ตลอด 24 ชั่วโมง',
  'mice-benefit-title-stop-service': 'ครบทุกความต้องการ',
  'mice-benefit-stop-service': 'ผสมผสานทุกบริการไว้ที่เดียว ตอบโจทย์ธุรกิจทุกรูปแบบ',
  'mice-benefit-title-professional': 'ทำงานอย่างมืออาชีพ',
  'mice-benefit-professional': 'ดูแลโดยทีมงานมืออาชีพ สร้างความประทับใจให้กับทุกทริป',
  'mice-service-choice-tile': 'ให้เราช่วยจัดหาบริการที่เหมาะกับคุณ',
  'mice-service-choice-sub-title': 'ด้วยบริการดูแลแบบครบวงจรที่คุณไม่ต้องเสียเวลาทำเอง สะดวกสบาย อยู่ที่ไหนก็จองได้ ปรีกษาฟรี! ไม่เสียค่าบริการใดๆ',
  'mice-service-choice-button': 'คลิกที่นี่',
  'mice-service-gallery-title': 'ภาพบรรยากาศและผลงานที่ผ่านมา',
  'mice-validation-pattern-contact-number': 'เบอร์ติดต่อต้องเป็นตัวเลข 0-9 จำนวน 9-10 หลัก',
  'mice-validation-pattern-email': 'อีเมลของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',

  'booking-cannot-be-processed-error-header': 'ไม่สามารถทำรายการจองได้',
  'booking-cannot-be-processed-error': 'กรุณาเลือกที่พักใหม่อีกครั้ง',
  'system-error': 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง',

  // Dialog Switch Company
  'dialog-switch-company-title': 'คุณต้องการเปลี่ยนไปใช้ข้อมูลภายใต้บริษัท',
  'dialog-switch-company-sub-title': 'สำหรับการจองที่พักเพื่อทำงาน สิทธิ์ที่คุณจะได้รับขึ้นอยู่กับแต่ละบริษัท กรุณาตรวจสอบข้อมูลของคุณตามด้านล่างนี้',
  'dialog-switch-company-payment-method': 'การชำระเงิน',
  'dialog-switch-company-budget': 'วงเงินต่อห้องต่อคืน',
  'dialog-switch-company-co-budget': 'วงเงินต่อห้องต่อคืน<br/>สำหรับผู้เข้าพัก 2 คน',
  'dialog-switch-company-budget-per-month': 'วงเงินต่อเดือน',
  'dialog-switch-company-budget-per-year': 'วงเงินต่อปี',
  'dialog-switch-company-tax-address': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'dialog-switch-company-allow': 'อนุญาต',
  'dialog-switch-company-allow-credit-terms': 'ใช้การชำระเงินแบบส่งใบแจ้งหนี้ (Credit Terms)',
  'dialog-switch-company-allow-corporate-fleet': 'ใช้การชำระเงินด้วยบัตรฟลีทบริษัท (Corporate Fleet Card)',
  'dialog-switch-company-not-allow': 'ไม่มีสิทธิ์',
  'dialog-switch-company-not-allow-credit-terms': 'ใช้การชำระเงินแบบส่งใบแจ้งหนี้ (Credit Terms)',
  'dialog-switch-company-not-allow-corporate-fleet': 'ไม่มีสิทธิ์ ใช้การชำระเงินด้วยบัตรฟลีทบริษัท (Corporate Fleet Card)',
  'dialog-switch-company-booking-under': 'หากต้องการเปลี่ยนไปจองห้องพักภายใต้สิทธิ์ของบริษัท',
  'dialog-switch-company-credit-card': ' คุณสามารถชำระเงินด้วยบัตรเครดิต/เดบิตเท่านั้น',
  'dialog-switch-company-warning': 'หรืออาจเปลี่ยนแปลงไปตามข้อมูลที่คุณเลือกในหน้าชำระเงิน',
  'dialog-switch-company-limit-room': 'จำนวนห้องพักที่จองได้ต่อครั้ง',
  'dialog-switch-company-room': 'ห้อง',
  'dialog-switch-company-multi-payment': 'จองที่พักเกินวงเงินและจ่ายส่วนต่างเอง',
  'dialog-switch-company-share-budget': 'รวมงบประมาณการจอง',
  'dialog-switch-company-limit-budget-warning': 'วงเงินของคุณจะเปลี่ยนแปลงตามจุดหมายปลายทางและช่วงวันที่คุณเลือกพัก',
  'dialog-switch-company-for': 'สำหรับ',
  'unlimited-budget': 'ไม่จำกัด',

  // Product Review
  'product-review-title': 'รีวิวจากผู้เข้าพัก',
  'product-review': 'รีวิว',
  'product-review-date': 'รีวิวเมื่อ',
  'product-review-order-by-review-date': 'รีวิวล่าสุด',
  'product-review-order-by-rating-desc': 'คะแนนรีวิวมากไปน้อย',
  'product-review-order-by-rating-asc': 'คะแนนรีวิวน้อยไปมาก',
  'product-review-image': 'ภาพรีวิวจากผู้เข้าพัก',
  'product-review-anonymous': 'ไม่ระบุชื่อ',

  // Dialog Budget suggestion
  'dialog-budget-suggestion-title': 'วงเงินการจองที่พัก',
  'dialog-budget-suggestion-desc': 'ระบบจะนำวงเงินที่คุณระบุไปคำนวณส่วนต่างในการเรียกเก็บเงินแบบแบ่งชำระ 2 ช่องทาง และวงเงินนี้จะถูกบันทึกไว้ใช้ในจองครั้งถัดไป โดยคุณสามารถแก้ไขได้อีกครั้งในขั้นตอนนี้',
  'dialog-budget-suggestion-form-btn-submit': 'ใช้วงเงินนี้',
  'dialog-budget-suggestion-form-btn-cancel': 'ยกเลิก',
  'dialog-budget-suggestion-label-budget': 'วงเงินต่อห้องต่อคืนของคุณ',
  'dialog-budget-suggestion-form-require-budget': 'กรุณาระบุวงเงินต่อห้องต่อคืนของคุณ',
  'dialog-budget-suggestion-form-exceed-limit-budget': 'กรุณาระบุวงเงินไม่เกิน THB 1,000,000',

  // Dialog Tax Address
  'dialog-tax-address-title-add-mode': 'เพิ่มที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',
  'dialog-tax-address-title-edit-mode': 'ที่อยู่สำหรับออกใบกำกับภาษี/ใบเสร็จ',

  // Filter Dropdown
  'filter-dropdown-no-results-match': 'ไม่พบผลลัพธ์การค้นหา',
  'form-autocomplete-no-result': 'ไม่พบข้อมูล',

  // Dialog
  'dialog-close': 'ปิด',
  'dialog-cancel': 'ยกเลิก',
  'dialog-confirm': 'เลือก',

  // Dropdown
  'default-dropdown': 'กรุณาเลือก',

  // Dialog confirm close
  'dialog-confirm-close-title': 'ออกจากหน้านี้',
  'dialog-confirm-close-desc': 'คุณต้องการออกจากหน้านี้โดยไม่ทำการบันทึกใช่หรือไม่?',
  'dialog-confirm-close-cancel': 'ยกเลิก',
  'dialog-confirm-close-confirm': 'ใช่ ออกจากหน้านี้',
  'dialog-confirm-change-search': 'เปลี่ยนการค้นหา',
  'dialog-confirm-change-continue-share-budget': 'จองต่อโดยใช้วงเงินคุณเอง',
  'dialog-confirm-cancel-share-budget': 'ยกเลิกการรวมวงเงิน',

  // Dialog confirm delete
  'dialog-confirm-delete-title': 'ลบข้อมูล',
  'dialog-confirm-delete-cancel': 'ยกเลิก',
  'dialog-confirm-delete-confirm': 'ลบ',

  // Dialog confirm delete address
  'dialog-confirm-delete-address-desc': 'คุณต้องการลบที่อยู่นี้ใช่หรือไม่?',

  // PDPA
  'pdpa-btn-accept': 'ยอมรับ',
  'pdpa-title': 'เงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัว',
  'pdpa-term-of-use': 'ข้อกำหนดและเงื่อนไขการใช้บริการ',
  'pdpa-privacy-notice': 'นโยบายความเป็นส่วนตัว',
  'cookies-policy': 'นโยบายคุกกี้',

  // Dialog Consent
  'dialog-consent-to-website': 'เรากำลังจะพาคุณไปยังหน้าเว็บไซต์',
  'dialog-consent-requesting-permission': 'โดยขอสิทธิ์การอนุญาตเข้าถึงข้อมูลต่อไปนี้',
  'dialog-consent-basic-information': 'เข้าถึงข้อมูลส่วนตัวพื้นฐานของคุณ',
  'dialog-consent-contact-information': 'เข้าถึงข้อมูลการติดต่อของคุณ',
  'dialog-consent-allow': 'อนุญาต',
  'dialog-consent-dont-allow': 'ไม่อนุญาต',
  'dialog-consent-full-name-etc': 'ชื่อ นามสกุล และข้อมูลอื่นๆ ที่คุณเปิดเผยกับ Ascend Travel',

  // Dialog Budget Available
  'dialog-budget-pay-option': 'คุณสามารถจองห้องพักโดยชำระเงินค่าที่พักเอง',
  'dialog-budget-pay-exceeding-option': 'คุณสามารถจองห้องพักโดยชำระส่วนที่เกินวงเงินเอง',
  'dialog-budget-cannot-share-budget-co-booker': 'ไม่สามารถรวมเงินกับผู้ร่วมเดินทางได้',

  // Dialog Cancel Share Budget
  'dialog-cancel-share-budget-text': 'คุณต้องการยกเลิกการรวมวงเงินใช่หรือไม่?',
  'dialog-cancel-share-budget-sub-text': 'เมื่อยกเลิกการรวมวงเงิน คุณจะสามารถจองห้องพัก ตามวงเงินที่คุณได้รับเท่านั้น',

  //Dialog PIN
  'dialog-set-pin-header': 'ตั้งรหัส PIN',
  'dialog-confirm-set-pin-header': 'ยืนยันรหัส PIN ใหม่อีกครั้ง',
  'dialog-set-pin-sub-header': 'กำหนดหมายเลข 6 ตัว เพื่อรักษาความปลอดภัยของบัญชี',
  'dialog-set-pin-sub-header-2': 'ใช้รหัส PIN สำหรับการชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทของคุณ',
  'dialog-verify-otp-header': 'ยืนยันตัวตน',
  'dialog-verify-otp-sub-header': 'กรุณาเลือกช่องทางด้านล่างในการยืนยันตัวตนของคุณ',
  'dialog-confirm-pin-booking-header': 'ยืนยันการจองด้วยรหัส PIN',
  'dialog-confirm-pin-booking-sub-header': 'กรุณาระบุรหัสรหัส PIN 6 หลัก สำหรับการชำระเงินแบบส่งใบแจ้งหนี้ เรียกเก็บเงินไปยังบริษัทของคุณ',
  'dialog-confirm-pin-booking-forgot-pin': 'ลืมรหัส PIN?',
  'dialog-confirm-pin-booking-set-new-pin': 'คลิกเพื่อไปตั้งรหัส PIN ใหม่',
  'dialog-alert-set-pin-title': 'บัญชีของคุณยังไม่มีการตั้งรหัส PIN',
  'dialog-alert-set-pin-description': 'เพื่อความปลอดภัยสำหรับการชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท กรุณาตั้งรหัส PIN ใหม่ได้ด้วยตัวเอง<br> โดยไปที่เมนู <b>บัญชี > ความปลอดภัยบัญชี > ตั้งรหัส PIN<b>',
  'dialog-alert-btn-confirm-set-pin': 'ตั้งรหัส PIN',
  'pin-code-incorrect': 'รหัส PIN ไม่ถูกต้อง',
  'set-pin-not-matched': 'รหัส PIN ไม่ตรงกับที่ยืนยัน กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'pin-too-weak': 'รหัส PIN ง่ายเกินไป โปรดเลือกใช้รหัส PIN ที่ปลอดภัยมากขึ้น',
  'pin-remaining-attempts': 'รหัส PIN ไม่ถูกต้อง กรุณาลองใหม่ คุณเหลือโอกาสอีก {x} ครั้ง ก่อนที่รหัส PIN จะถูกล็อก',
  'pin-locked': 'รหัส PIN ถูกล็อก คุณสามารถไปตั้งรหัส PIN ใหม่ <br>หรือติดต่อ Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
  'otp-title': 'ยืนยันตัวตน',
  'otp-select-channel': 'กรุณาเลือกช่องทางด้านล่างในการยืนยันตัวตนของคุณ',
  'otp-send-to': 'ส่งรหัสยืนยันไปที่',
  'otp-resend': 'ส่งรหัสยืนยันอีกครั้ง',
  'otp-reference': 'รหัสอ้างอิง: ',
  'otp-code-incorrect': 'รหัสยืนยันไม่ถูกต้อง',
  'otp-last-attempts': 'รหัสยืนยันไม่ถูกต้อง กรุณาลองใหม่ คุณเหลือโอกาสอีก 1 ครั้ง หากคุณระบุรหัสยืนยันผิดเกินจำนวนครั้งที่กำหนดบัญชีจะถูกล็อกชั่วคราว',
  'otp-remaining-attempts': 'รหัสยืนยันไม่ถูกต้อง กรุณาลองใหม่ คุณเหลือโอกาสอีก {x} ครั้งก่อนที่บัญชีจะถูกล็อก',
  'otp-try-another-way': 'ลองวิธีอื่น',
  'setup-pin-success': 'ตั้งรหัส PIN เรียบร้อยแล้ว',
  'dialog-otp-verify-sub-header': 'เราได้ส่งรหัสยืนยันไปที่',
  'dialog-otp-verify-email-sub-header': 'กรุณาตรวจสอบอีเมลและกรอกรหัสด้านล่างภายใน 15 นาที หลังได้รับอีเมล',
  'dialog-otp-verify-sms-sub-header': 'กรุณาตรวจสอบข้อความและกรอกรหัสด้านล่างภายใน 15 นาที หลังได้รับข้อความ',
  'email': 'อีเมล',
  'phone': 'เบอร์โทรศัพท์',
  'account-locked': 'บัญชีถูกล็อก เนื่องจากคุณระบุรหัสยืนยันผิดเกินจำนวนครั้งที่กำหนด หากต้องการปลดล็อก สามารถติดต่อ Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
  'session-expired': 'เซสชันหมดอายุ กรุณาทำรายการใหม่อีกครั้ง',

  // Dialog Phone
  'dialog-set-phone-header': 'ระบุเบอร์โทรศัพท์',
  'dialog-set-phone-sub-header': 'กรุณาระบุเบอร์โทรศัพท์ที่คุณต้องการเชื่อมกับบัญชี',
  'dialog-set-phone-label-phone-number': 'เบอร์โทรศัพท์',
  'dialog-set-phone-require-mobile-number': 'กรุณากรอกเบอร์โทรศัพท์',
  'dialog-set-phone-invalid-mobile-number': 'กรุณาระบุเบอร์ติดต่อที่ถูกต้อง',
  'change-phone-success': 'เชื่อมเบอร์โทรศัพท์กับบัญชีเรียบร้อยแล้ว',

  // Badge or Notices
  'sanitized-stay': 'มั่นใจเมื่อเข้าพัก',
  'sanitized-stay-hover': 'ที่พักมีมาตรการพิเศษเพื่อความปลอดภัยด้านสุขนามัยในการให้บริการผู้เข้าพัก',
  'year-of-build-badge': 'สร้างใหม่ {yyyy}',
  'year-of-renovated-badge': 'ปรับปรุงใหม่ {yyyy}',
  'security-standard-badge': 'มาตรฐานความปลอดภัย',
  'security-standard-badge-hover': 'ที่พักได้รับการตรวจสอบเป็นพิเศษเรื่องมาตรฐานความปลอดภัยจากหน่วยงานที่เกี่ยวข้องแล้ว',

  // Budget Limit
  'budget-limit-special-budget-for-destination': 'วงเงินพิเศษสำหรับการจองจุดหมายปลายทางนี้',
  'budget-limit-special-budget-for-poi': 'วงเงินในการจองที่พักขึ้นอยู่กับจุดหมายปลายทางที่เลือก',
  'budget-limit-special-budget-for-poi-new': 'คุณมีวงเงินใหม่ในการจองที่พักขึ้นอยู่กับจุดหมายปลายทางที่คุณเลือก',
  'budget-limit-normal-budget': 'วงเงินปกติ',
  'budget-limit-tittle': 'คุณมีวงเงินพิเศษสำหรับการจองจุดหมายปลายทางนี้',
  'budget-limit-detail': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันเท่านั้น วงเงินที่แสดงจึงเป็นวงเงินเฉลี่ยจากช่วงวันเข้าพักและจำนวนคืนที่คุณเลือกตามรายละเอียดด้านล่างนี้',
  'budget-limit-detail-poi': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันและบางจุดหมายปลายทางเท่านั้น คุณสามารถกดดูเพิ่มเติมเพื่อดูวงเงินทั้งหมดของคุณได้',
  'budget-limit-dialog-detail-poi': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันและบางจุดหมายปลายทางเท่านั้น วงเงินที่แสดงจึงเป็นวงเงินเฉลี่ยจากช่วงวันเข้าพักและจำนวนคืนที่คุณเลือกตามรายละเอียดด้านล่างนี้',
  'budget-limit-detail-bottom-poi': 'วงเงินต่อห้องต่อคืนที่สามารถใช้ได้จะขึ้นอยู่กับจุดหมายปลายทางของที่พักที่คุณเลือก',
  'budget-limit-net-budget': 'วงเงินต่อห้องต่อคืน สำหรับช่วงวันเข้าพักที่เลือกค้นหา',
  'budget-limit-more-detail': 'ดูเพิ่มเติม',
  'budget-limit-day-check-in': 'วันที่เข้าพัก',
  'budget-limit-budget-per-night': 'วงเงินต่อคืน',
  'budget-limit-sum-budget-per-night': 'วงเงินรวมต่อคืน',
  'budget-limit-budget-special': 'วงเงินพิเศษ',
  'budget-limit-budget-per-night-per-room': 'วงเงินต่อห้องต่อคืน',
  'budget-limit-for-search': 'สำหรับช่วงวันเข้าพักที่เลือกค้นหา',
  'budget-limit-and': 'และ',
  'budget-limit-for': 'สำหรับ',
  'budget-limit-unlimited': 'ไม่จำกัด',
  'budget-limit-view-detail': 'ดูรายละเอียด',
  'budget-limit-unlimited-share-budget': 'คุณมีวงเงินใหม่ในการจองที่พักต่อห้องต่อคืนไม่จำกัด',
  'budget-limit-share-budget': 'คุณมีวงเงินใหม่ในการจองที่พักอยู่ <strong>{x}</strong> /ห้อง/คืน',
  'budget-limit-share-budget-title': 'คุณได้รวมกับวงเงินของผู้ร่วมเดินทาง และมีวงเงินพิเศษสำหรับการจองจุดหมายปลายทางนี้',
  'budget-limit-share-budget-detail': 'เนื่องจากมีวงเงินพิเศษเฉพาะบางวันเท่านั้น วงเงินที่แสดงจึงเป็นวงเงินเฉลี่ยจากช่วงวันเข้าพักและจำนวนคืนที่คุณเลือก',
  'budget-limit-booker-budget': 'วงเงินของคุณ',
  'budget-limit-co-booker-budget': 'วงเงินของผู้ร่วมเดินทาง',
  'budget-limit-co-booker-budget-new-tab': 'วงเงินของ<br>ผู้ร่วมเดินทาง',
  'budget-limit-total-budget': 'วงเงินรวมต่อคืน',
  'budget-limit-normal-budget-booker': 'วงเงินปกติของคุณ',
  'budget-limit-normal-budget-co-booker': 'วงเงินปกติของผู้ร่วมเดินทาง',
  'budget-limit-applied-co-budget': '**มีการจำกัดวงเงินในการจองห้องพักสำหรับผู้เข้าพัก 2 คน',

  // My Budget
  'my-budget-title': 'สิทธิ์และวงเงินการจองที่พัก',
  'my-budget-under': 'ภายใต้บริษัท {companyName}',
  'my-budget-user-permission-detail-title': 'สิทธิ์การจองที่พัก',
  'my-budget-budget-detail-title': 'วงเงิน',
  'my-budget-month': 'เดือน',
  'my-budget-budget-used': 'ยอดที่ใช้ไป',
  'my-budget-budget-per-month-remaining': 'วงเงินต่อเดือนคงเหลือ',
  'my-budget-budget-per-year-remaining': 'วงเงินต่อปีคงเหลือ',
  'my-budget-badge-per-month-remaining': 'วงเงินต่อเดือนคงเหลือ',
  'my-budget-badge-per-monht-used': 'จากวงเงินต่อเดือนทั้งหมด คุณใช้ไป',
  'my-budget-badge-per-year-remaining': 'วงเงินต่อปีคงเหลือ',
  'my-budget-badge-per-year-used': 'จากวงเงินต่อปีทั้งหมด คุณใช้ไป',
  'my-budget-year': 'ปี',

  // Share Budget Code
  'share-budget-code-title': 'สร้างรหัสสำหรับรวมวงเงิน',
  'share-budget-code-content-title': 'รหัสสำหรับรวมวงเงิน คือรหัสสำหรับให้ผู้จองหลักใช้รวมวงเงินการจองที่พักกับคุณ',
  'share-budget-code-generate-code': 'สร้างรหัส',
  'share-budget-code-copy-code': 'คัดลอกรหัส',
  'share-budget-code-text': 'รหัสสำหรับรวมวงเงิน',
  'share-budget-code-generate-code-link': 'สร้างรหัสใหม่',
  'share-budget-code-copied': 'คัดลอกรหัสแล้ว',
  'share-budget-code-description': 'เมื่อสร้างรหัสเรียบร้อยแล้วจะสามารถใช้ได้ภายใน 24 ชั่วโมงเท่านั้น หากคุณสร้างรหัสใหม่ รหัสที่เคยสร้างไว้จะหมดอายุทันที',
  'share-budget-code-select-company-label': 'กรุณาเลือกบริษัทที่ต้องการรวมวงเงินการจอง',
  'share-budget-code-defalut-company': 'เลือกบริษัท',
  'share-budget-code-not-allow': 'บริษัทของคุณไม่อนุญาตให้รวมวงเงิน',

  // Dialog Share Budget
  'dialog-share-budget-title': 'รวมวงเงินการจองกับผู้ร่วมเดินทาง',
  'dialog-share-budget-sub-title': 'คุณต้องได้รับความยินยอมจากผู้ร่วมเดินทางก่อนการจองทุกครั้ง สำหรับการจองครั้งนี้ ผู้ร่วมเดินทางจะถือว่าเป็น <b>“ผู้จองร่วม”</b> และวงเงินในการจองที่พักจะเป็นวงเงินชั่วคราวของคุณและผู้ร่วมเดินทางของคุณ',
  'dialog-share-budget-code-ref': 'รหัสสำหรับรวมวงเงิน',
  'dialog-share-budget-code-ref-change': 'เปลี่ยน',
  'dialog-share-budget-co-booker-email': 'อีเมลผู้ร่วมเดินทาง',
  'dialog-share-budget-co-booker-company': 'ผู้ร่วมเดินทางภายใต้บริษัท',
  'dialog-share-budget-co-booker-company-address': 'ที่อยู่ออกใบกำกับภาษี/ใบเสร็จ',
  'dialog-share-budget-error-code-ref-require': 'กรุณาใส่รหัสสำหรับรวมวงเงิน',
  'dialog-share-budget-error-code-ref-incorrect': 'รหัสสำหรับรวมวงเงินไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'dialog-share-budget-error-code-ref-expired': 'รหัสสำหรับรวมวงเงินหมดอายุแล้ว กรุณาตรวจสอบและลองใหม่อีกครั้ง',
  'dialog-share-budget-error-code-ref-yourself': 'ไม่สามารถรวมวงเงินกับตัวเองได้',
  'dialog-share-budget-error-code-ref-not-allow-feature': 'รหัสไม่สามารถใช้งานได้ เนื่องจากบริษัทของคุณหรือผู้ร่วมเดินทางไม่อนุญาตให้รวมวงเงินการจอง',
  'dialog-share-budget-gen-code-link': 'ผู้จองร่วมสามารถสร้างรหัสสำหรับรวมวงเงินได้ที่',
  'dialog-share-budget-copy-link': 'คัดลอกลิงก์',
  'dialog-share-budget-copy-link-to-clipboard': 'คัดลอกลิงก์แล้ว',
  'dialog-share-budget-company': 'บริษัท',
  'dialog-share-budget-tax-id': 'หมายเลขประจำตัวผู้เสียภาษี',
  'dialog-share-budget-confirm-share-budget': 'รวมวงเงิน',

  //Dialog payment
  'dialog-payment-title': 'รายการชำระเงินแบ่งเป็น 2 ช่องทาง',
  'dialog-payment-sub-title': 'กรุณาเลือกช่องทางการชำระเงินที่คุณต้องการ',
  'dialog-payment-main-payment': 'รายการชำระเงินหลัก',
  'dialog-payment-extra-payment': 'รายการชำระเงินเพิ่มเอง',

  // Form Share Budget
  'form-share-budget-title': 'รายการชำระเงิน',
  'form-share-budget-title-multi': 'รายการชำระเงิน',
  'form-share-budget-credit-terms-title': 'ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
  'form-share-budget-credit-terms-booker': 'ยอดชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทคุณ  ',
  'form-share-budget-credit-terms-co-booker': 'ยอดชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัทผู้ร่วมเดินทาง',
  'form-share-budget-other-payment': 'ชำระเงินเพิ่มด้วย',
  'form-share-budget-other-payment-credit-terms': 'ชำระเงินแบบส่งใบแจ้งหนี้เรียกเก็บเงินไปยังบริษัท',
  'form-share-budget-other-payment-credit-card': 'บัตรเครดิต/เดบิต',
  'form-share-budget-other-payment-true-money': 'ทรูมันนี่ วอลเล็ท',
  'form-share-budget-other-payment-personal-fleet': 'บัตรฟลีทส่วนตัว',

  'room-special-request-optional': ' - ถ้ามี',
  'room-special-request-sub-title': `เราจะส่งคำขอของคุณให้ที่พักทราบทันทีหลังจากที่จอง ไม่สามารถรับประกันการให้บริการตามคำขอได้ แต่ที่พักจะดำเนินการอย่างสุดความสามารถเพื่อความประสงค์ของคุณ และอาจมีค่าใช้จ่ายเพิ่มเติม`,
  'room-special-preferred-room': 'ประเภทห้องที่ต้องการ',
  'room-special-request-non-smoke-room': 'ห้องปลอดบุหรี่',
  'room-special-request-smoke-room': 'ห้องสูบบุหรี่ได้',
  'room-special-preferred-bed': 'ประเภทเตียงที่ต้องการ',
  'room-special-request-large-bed': 'เตียงใหญ่',
  'room-special-request-twin-bed': 'เตียงแฝด',
  'room-special-more-special-requests': 'ขอรับบริการอื่นๆ',
  'room-special-request-high-floor-room': 'ห้องพักที่อยู่ชั้นสูง',
  'room-special-request-connecting-room': 'ห้องพักแบบเชื่อมถึงกัน',
  'room-special-request-quiet-room': 'ห้องพักเงียบสงบ',
  'room-special-others-en': 'เพิ่มเติม (กรุณาใส่ข้อมูลเป็นภาษาอังกฤษ เท่านั้น)',
  'room-special-others': 'เพิ่มเติม',
  'room-special-more-request': 'อื่นๆ',

  // Dialog Information Cart
  'dialog-information-cart-title': 'ข้อมูลที่ควรทราบ',
  'dialog-information-cart-sub-title': 'กรุณาอ่านเงื่อนไขของห้องพักก่อนยืนยันการจอง เนื่องจากข้อมูลมีการเปลี่ยนแปลง หรืออาจมีค่าใช้จ่ายเพิ่มเติมเมื่อเข้าพัก ตามรายละเอียดด้านล่าง',
  'dialog-information-cart-accept-condition': 'ยอมรับข้อตกลงและเงื่อนไข',
  'dialog-information-cart-accept-condition-required': 'กรุณากดยอมรับข้อตกลงและเงื่อนไข',

  // Fleet Card Information
  'fleet-card-status-active': 'เปิดใช้งาน',
  'fleet-card-status-inactive': 'ปิดใช้งาน',
  'fleet-card-status-expired': 'หมดอายุ',
  'fleet-card-type-corporate': 'บริษัท',
  'fleet-card-type-personal': 'บัตรฟลีทส่วนตัว',
  'fleet-card-information-card-personal': 'บัตรฟลีทส่วนตัว',
  'fleet-card-no-expiration-date': 'ไม่มีวันหมดอายุ',
  'fleet-card-information-fleet-card-type-all': 'ทั้งหมด',
  'fleet-card-information-fleet-card-type-corporate': 'บริษัท',
  'fleet-card-information-fleet-card-type-personal': 'ส่วนตัว',
  'fleet-card-information-title': 'บัตรฟลีท (Fleet Card)',
  'fleet-card-information-register': 'เพิ่มบัตรใหม่',
  'fleet-card-information-fleet-card-no-label': 'หมายเลขบัตรฟลีท',
  'fleet-card-information-redeemed-amount': 'ยอดที่ใช้ไปทั้งหมด',
  'fleet-card-information-balance-amount': 'ยอดเงินคงเหลือ',
  'fleet-card-information-information-label': 'ข้อมูลบัตร',
  'fleet-card-information-status-label': 'สถานะบัตร',
  'fleet-card-information-type-label': 'ประเภทบัตร',
  'fleet-card-information-company-label': 'ภายใต้บริษัท',
  'fleet-card-information-expiration-label': 'วันหมดอายุ',
  'fleet-card-information-topup': 'เติมเงินเข้าบัตร',
  'fleet-card-information-transfer': 'โอนเงินระหว่างบัตร',
  'fleet-card-information-no-fleet-title': 'ไม่มีบัตรฟลีทในบัญชีของคุณ',
  'fleet-card-information-no-fleet-description-1': 'หากคุณมีบัตรฟลีทแล้ว กรุณาคลิก “เพิ่มบัตรใหม่” เพื่อเริ่มต้นใช้งาน',
  'fleet-card-information-no-fleet-description-2': 'หากคุณต้องการซื้อบัตรฟลีท สามารถติดต่อได้ 2 ช่องทาง',
  'fleet-card-information-no-fleet-company-title': 'ไม่มีบัตรฟลีทบริษัทในบัญชีของคุณ',
  'fleet-card-information-no-fleet-personal-title': 'ไม่มีบัตรฟลีทส่วนตัวในบัญชีของคุณ',

  // Dialog Fleet Card Top Up
  'dialog-fleet-card-top-up-title': 'เราจะเปิดให้บริการเติมเงินผ่านช่องทางออนไลน์เร็วๆนี้',
  'dialog-fleet-card-top-up-sub-title-1': 'หากคุณต้องการซื้อบัตรฟลีทเพิ่ม สามารถติดต่อได้ 2 ช่องทาง',

  // Dialog Fleet Card Register
  'dialog-fleet-card-register-title': 'เพิ่มบัตรฟลีท (Fleet Card)',
  'dialog-fleet-card-register-fleet-card-no-label': 'หมายเลขบัตรฟลีท',
  'dialog-fleet-card-register-fleet-card-no-error-required': 'กรุณาระบุหมายเลขบัตรฟลีท',
  'dialog-fleet-card-register-secret-code-label': 'รหัสลับ',
  'dialog-fleet-card-register-secret-code-tooltip': `รหัสลับ คือรหัสคู่กับบัตรฟลีท ใช้สำหรับเพิ่มบัตรฟลีทเข้าบัญชีของคุณ เพื่อยืนยันว่าเป็นผู้ถือบัตรจริง โดยรหัสลับ จะถูกส่งเข้าอีเมลที่ผู้ชำระเงินซื้อบัตรได้ระบุไว้`,
  'dialog-fleet-card-register-secret-code-error-required': 'กรุณาระบุรหัสลับ',
  'dialog-fleet-card-register-fleet-card-no-or-secret-code-invalid': 'หมายเลขบัตร หรือรหัสลับไม่ถูกต้อง',
  'dialog-fleet-card-register-fleet-card-is-already-registered': 'หมายเลขบัตรนี้ถูกเพิ่มแล้ว',
  'dialog-fleet-card-register-fleet-card-is-expired': 'หมายเลขบัตรนี้หมดอายุแล้ว ',
  'dialog-fleet-card-register-fleet-card-cannot-register-company': 'หมายเลขบัตรนี้ไม่สามารถเพิ่มได้สำหรับบริษัทของคุณ ',

  // Fleet Card Transaction History
  'fleet-card-transaction-history-title': 'ประวัติรายการ',
  'fleet-card-transaction-history-filter-date-all': 'ทั้งหมด',
  'fleet-card-transaction-history-filter-by': 'แสดง',
  'fleet-card-transaction-history-filter-all': 'รายการทั้งหมด',
  'fleet-card-transaction-history-filter-redeem': 'รายการชำระเงิน',
  'fleet-card-transaction-history-filter-transfer-withdrawal': 'รายการโอนเงิน',
  'fleet-card-transaction-history-filter-transfer-deposit': 'รายการรับโอนเงิน',
  'fleet-card-transaction-history-filter-refund': 'รายการคืนเงิน',
  'fleet-card-transaction-history-date': 'วันที่บันทึกรายการ',
  'fleet-card-transaction-history-activity': 'รายการ',
  'fleet-card-transaction-history-balance': 'ยอดเงิน',
  'fleet-card-transaction-history-text-redeem': 'มีรายการใช้บัตร หมายเลขการจอง',
  'fleet-card-transaction-history-text-transfer-withdrawal': 'โอนเงิน ไปยัง',
  'fleet-card-transaction-history-text-transfer-deposit': 'เงินเข้า จาก',
  'fleet-card-transaction-history-text-refund': 'รายการคืนเงิน หมายเลขการจอง',
  'fleet-card-transaction-history-no-transaction': 'ไม่มีประวัติรายการ',

  // Dialog Fleet Card Register Complete
  'dialog-fleet-card-register-complete-title': 'เพิ่มบัตรใหม่เรียบร้อยแล้ว',
  'dialog-fleet-card-register-complete-fleet-card-no-label': 'หมายเลขบัตร',
  'dialog-fleet-card-register-complete-fleet-card-type-label': 'ประเภทบัตร',
  'dialog-fleet-card-register-complete-company-label': 'ภายใต้บริษัท',
  'dialog-fleet-card-register-complete-expiration-date-label': 'วันหมดอายุ',
  'dialog-fleet-card-register-complete-amount-label': 'จำนวนเงิน',

  // Checkout 3 Fleet Card
  'checkout-3-fleet-card-title': 'ข้อมูลบัตรฟลีท',
  'checkout-3-personal-fleet-title': 'ข้อมูลบัตรฟลีทส่วนตัว',
  'checkout-3-corporate-fleet-title': 'ข้อมูลบัตรฟลีทบริษัท',
  'checkout-3-fleet-card-no-you-account': 'ไม่มีบัตรฟลีทในบัญชีของคุณ',
  'checkout-3-fleet-card-no-you-account-sub-1': 'หากคุณมีบัตรฟลีทแล้ว กรุณาลงทะเบียนเพื่อเริ่มต้นใช้งานบัตรที่เมนู <i class="icon-fleet"> <b>บัตรฟลีท (Fleet Card)</b>',
  'checkout-3-fleet-card-no-you-account-sub-2': 'หากคุณต้องการซื้อบัตรฟลีท กรุณาติดต่อ Call Center +66(0) 2-020-2351',
  'checkout-3-fleet-card-no-you-account-sub-3': 'หรือ Line Official Account',
  'checkout-3-fleet-card-information': 'รายการชำระเงินด้วยบัตรฟลีท',
  'checkout-3-fleet-card-payment-date': 'จะตัดเงินวันที่',
  'checkout-3-personal-fleet': 'บัตรส่วนตัว',
  'checkout-3-fleet-card-cannot-selected-error': 'ยอดเงินคงเหลือในบัตรไม่เพียงพอ กรุณาเลือกบัตรใหม่หรือเปลี่ยนช่องทางการชำระเงิน',
  'checkout-3-fleet-card-cannot-selected-error-multi': 'ยอดชำระเกินวงเงินที่ได้รับ กรุณาเลือกบัตรใหม่หรือเปลี่ยนช่องทางการชำระเงิน',

  // Dialog Fleet Card Transfer
  'dialog-fleet-card-transfer-default-dropdown': 'เลือกหมายเลขบัตรฟลีท',
  'dialog-fleet-card-transfer-title': 'โอนเงินระหว่างบัตร',
  'dialog-fleet-card-transfer-sub-title': 'สามารถโอนเงินในบัตรไปยังบัตรประเภทเดียวกัน หรือภายใต้บริษัทเดียวกัน และบัตรต้องไม่มีวันหมดอายุ',
  'dialog-fleet-card-transfer-fleet-card-no-from-label': 'จากหมายเลขบัตร',
  'dialog-fleet-card-transfer-fleet-card-no-to-label': 'ไปยังหมายเลขบัตร',
  'dialog-fleet-card-transfer-fleet-card-no-to-note': 'รายการบัตรจะแสดงเฉพาะบัตรที่สามารถโอนเงินได้เท่านั้น',
  'dialog-fleet-card-transfer-amount-label': 'จำนวนเงิน',
  'dialog-fleet-card-transfer-amount-error-required': 'กรุณาระบุจำนวนเงิน',
  'dialog-fleet-card-transfer-amount-error-insufficient': 'จำนวนเงินในบัตรไม่เพียงพอ',
  'dialog-fleet-card-transfer-amount-error-exceed': 'จำนวนเงินในบัตรปลายทางเกินวงเงินสูงสุดของบัตร',

  // Dialog Fleet Card Transfer Complete
  'dialog-fleet-card-transfer-complete-title': 'โอนเงินระหว่างบัตรเรียบร้อยแล้ว',
  'dialog-fleet-card-transfer-complete-from-label': 'จากหมายเลขบัตร',
  'dialog-fleet-card-transfer-complete-to-label': 'ไปยังหมายเลขบัตร',
  'dialog-fleet-card-transfer-complete-amount-label': 'จำนวนเงิน',

  // Dialog Fleet Card Register Fail
  'dialog-fleet-card-register-fail-title': 'เพิ่มบัตรไม่สำเร็จ',
  'dialog-fleet-card-register-fail-sub-title': 'กรุณาทำรายการใหม่อีกครั้ง',

  // Dialog Fleet Card Transfer Fail
  'dialog-fleet-card-transfer-fail-title': 'โอนเงินระหว่างบัตรไม่สำเร็จ',
  'dialog-fleet-card-transfer-fail-sub-title': 'กรุณาทำรายการใหม่อีกครั้ง',

  'payment-channel-type-multi-payment': 'แบ่งชำระเงิน 2 ช่องทาง',
  'payment-channel-type-credit-terms': 'ชำระเงินแบบส่งใบแจ้งหนี้',
  'payment-channel-type-credit-card': 'บัตรเครดิต/เดบิต',
  'payment-channel-type-true-money': 'ทรูมันนี่ วอลเล็ท',
  'payment-channel-type-personal-fleet': 'บัตรฟลีทส่วนตัว',
  'payment-channel-type-corporate-fleet': 'บัตรฟลีทบริษัท',
  'payment-channel-type-fleet-card': 'บัตรฟลีท',
  'payment-channel-type-personal-payment': '* ชำระเองเต็มจำนวน *',
  'payment-channel-type-qr-code': 'QR Code',
  'payment-channel-type-e-wallet': 'E-Wallet',
  'payment-channel-type-im-banking': 'ธนาคารออนไลน์',
  'payment-channel-type-pay-at-counter': 'เคาน์เตอร์',

  'payment-method-collapse': 'ย่อ',
  'payment-method-expanse': 'แสดงช่องทางชำระเงินทั้งหมด',

  'check-in-check-out': 'เช็คอิน/เช็คเอาท์',
  'check-in-from': 'เช็คอินได้ตั้งแต่',
  'check-out-until': 'เช็คเอาท์ได้จนถึง',
  'check-out-from': 'เช็คเอาท์ได้ตั้งแต่',
  'early-late-check-in': 'โปรดติดต่อที่พักล่วงหน้า หากต้องการเช็คอินนอกเหนือเวลาดังกล่าว',
  'product-description': 'รายละเอียด',

  'product-images': 'ดูรูปภาพทั้งหมด',
  'all-photos': 'รูปภาพทั้งหมด',

  // product item
  'product-hot-deal': 'ดีลสุดฮอต!',
  'product-promotion-last-minute': '<strong>ราคาพิเศษ</strong> <span>นาทีสุดท้าย!</span>',
  'product-discount-percent': 'ลด <strong>{price}</strong>%',
  'product-discount-amount': 'ลด <strong>THB {price}</strong>',

  'info-window-content-navigate': 'ดูเส้นทาง',

  // arrival time
  'arrival-time-i-dont-know': 'ไม่ทราบเวลาแน่ชัด',
  'arrival-time-0000-0100': '00:00 - 01:00',
  'arrival-time-0100-0200': '01:00 - 02:00',
  'arrival-time-0200-0300': '02:00 - 03:00',
  'arrival-time-0300-0400': '03:00 - 04:00',
  'arrival-time-0400-0500': '04:00 - 05:00',
  'arrival-time-0500-0600': '05:00 - 06:00',
  'arrival-time-0600-0700': '06:00 - 07:00',
  'arrival-time-0700-0800': '07:00 - 08:00',
  'arrival-time-0800-0900': '08:00 - 09:00',
  'arrival-time-0900-1000': '09:00 - 10:00',
  'arrival-time-1000-1100': '10:00 - 11:00',
  'arrival-time-1100-1200': '11:00 - 12:00',
  'arrival-time-1200-1300': '12:00 - 13:00',
  'arrival-time-1300-1400': '13:00 - 14:00',
  'arrival-time-1400-1500': '14:00 - 15:00',
  'arrival-time-1500-1600': '15:00 - 16:00',
  'arrival-time-1600-1700': '16:00 - 17:00',
  'arrival-time-1700-1800': '17:00 - 18:00',
  'arrival-time-1800-1900': '18:00 - 19:00',
  'arrival-time-1900-2000': '19:00 - 20:00',
  'arrival-time-2000-2100': '20:00 - 21:00',
  'arrival-time-2100-2200': '21:00 - 22:00',
  'arrival-time-2200-2300': '22:00 - 23:00',
  'arrival-time-2300-2400': '23:00 - 24:00',
  'arrival-time-0000-0100-the-next-day': '00:00 - 01:00 (วันถัดไป)',
  'arrival-time-0100-0200-the-next-day': '01:00 - 02:00 (วันถัดไป)',

  'view-more': 'แสดงทั้งหมด',
  'view-less': 'ซ่อนทั้งหมด',

  //Modal Update Profile
  'positive-energy-title' : 'ค้นหาที่พักเสริมพลังบวก',
  'positive-energy-title-desc' : 'เพียงระบุวันเกิดของคุณ เราจะช่วยค้นหาที่พักที่เสริมพลังบวก โดยใช้วิธีคำนวณจากศาสตร์ตัวเลข',
  'positive-energy-description' : 'ข้อมูลวันเดือนปีเกิดและช่วงเวลาเกิดจะถูกเก็บไว้<strong>เป็นความลับและได้รับความคุ้มครองตามกฎหมายที่เกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล</strong> โดยใช้สำหรับประมวลผลเพื่อแนะนำที่พักเสริมพลังบวกเท่านั้น <strong>ไม่ส่งผลกระทบกับการค้นหาที่พักแบบเดิม</strong> เมื่อกรอกข้อมูลแล้วถือว่าคุณยอมรับและเข้าใจ <a class="link-hover-style" href="https://www.ascendtravel.com/privacy-policy?lang=th" target="_blank">นโยบายความเป็นส่วนตัว</a> ของ AscendTravel.com',
  'full-name-description' : 'กรุณาระบุข้อมูลเป็นภาษาอังกฤษเท่านั้น ตามที่ปรากฏในหนังสือเดินทาง/บัตรประจำตัวประชาชน (ไม่ต้องระบุคำนำหน้า/ตัวอักษรพิเศษ)',
  'time-of-birth-label' : 'ช่วงเวลาเกิด',
  'time-of-birth-placeholder' : 'ระบุช่วงเวลาเกิด',
  'time-of-birth-option-unspecified' : 'ไม่ทราบช่วงเวลาเกิด',
  'time-of-birth-option-day' : 'กลางวัน (6:00 - 17:59 น.)',
  'time-of-birth-option-night' : 'กลางคืน (18:00 - 05:59 น.)',
  'time-of-birth-day': 'กลางวัน',
  'time-of-birth-night': 'กลางคืน',
  'positive-energy-btn-submit' : 'ค้นหา'
};



// WEBPACK FOOTER //
// ./src/translation/lang-th.ts